function PlanN({ ...props }) {
	return (
		<g id="plan-n">
			<g id="furniture">
				<polyline
					points="677.27 789 677.27 783.03 680.29 783.03 680.29 789 677.27 789"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="74.17"
					y1="567.48"
					x2="378.35"
					y2="567.48"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="378.35"
					y1="612.8"
					x2="373.46"
					y2="612.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="369.11"
					y1="612.8"
					x2="361.86"
					y2="612.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="357.51"
					y1="612.8"
					x2="350.26"
					y2="612.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="345.91"
					y1="612.8"
					x2="338.65"
					y2="612.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="276.3"
					y1="612.8"
					x2="269.04"
					y2="612.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="264.69"
					y1="612.8"
					x2="257.44"
					y2="612.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="253.09"
					y1="612.8"
					x2="245.84"
					y2="612.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="241.49"
					y1="612.8"
					x2="234.24"
					y2="612.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="229.89"
					y1="612.8"
					x2="222.64"
					y2="612.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="218.29"
					y1="612.8"
					x2="211.03"
					y2="612.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="206.68"
					y1="612.8"
					x2="199.43"
					y2="612.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="195.08"
					y1="612.8"
					x2="187.83"
					y2="612.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="183.48"
					y1="612.8"
					x2="176.23"
					y2="612.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="171.88"
					y1="612.8"
					x2="164.63"
					y2="612.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="160.28"
					y1="612.8"
					x2="153.02"
					y2="612.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="148.67"
					y1="612.8"
					x2="141.42"
					y2="612.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="137.07"
					y1="612.8"
					x2="129.82"
					y2="612.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="125.47"
					y1="612.8"
					x2="118.22"
					y2="612.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="74.17"
					y1="589.47"
					x2="74.17"
					y2="582.22"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="74.17"
					y1="577.87"
					x2="74.17"
					y2="570.5"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="74.17"
					y1="570.5"
					x2="79.06"
					y2="570.5"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="83.41"
					y1="570.5"
					x2="90.66"
					y2="570.5"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="95.02"
					y1="570.5"
					x2="102.27"
					y2="570.5"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="106.62"
					y1="570.5"
					x2="113.87"
					y2="570.5"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="118.22"
					y1="570.5"
					x2="125.47"
					y2="570.5"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="129.82"
					y1="570.5"
					x2="137.07"
					y2="570.5"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="141.42"
					y1="570.5"
					x2="148.67"
					y2="570.5"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="153.02"
					y1="570.5"
					x2="160.28"
					y2="570.5"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="164.63"
					y1="570.5"
					x2="171.88"
					y2="570.5"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="176.23"
					y1="570.5"
					x2="183.48"
					y2="570.5"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="187.83"
					y1="570.5"
					x2="195.08"
					y2="570.5"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="199.43"
					y1="570.5"
					x2="206.68"
					y2="570.5"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="211.03"
					y1="570.5"
					x2="218.29"
					y2="570.5"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="222.64"
					y1="570.5"
					x2="229.89"
					y2="570.5"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="234.24"
					y1="570.5"
					x2="241.49"
					y2="570.5"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="245.84"
					y1="570.5"
					x2="253.09"
					y2="570.5"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="257.44"
					y1="570.5"
					x2="264.69"
					y2="570.5"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="269.04"
					y1="570.5"
					x2="276.3"
					y2="570.5"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="280.65"
					y1="570.5"
					x2="287.9"
					y2="570.5"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="292.25"
					y1="570.5"
					x2="299.5"
					y2="570.5"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="303.85"
					y1="570.5"
					x2="311.1"
					y2="570.5"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="315.45"
					y1="570.5"
					x2="322.7"
					y2="570.5"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="327.05"
					y1="570.5"
					x2="334.3"
					y2="570.5"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="338.65"
					y1="570.5"
					x2="345.91"
					y2="570.5"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="350.26"
					y1="570.5"
					x2="357.51"
					y2="570.5"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="361.86"
					y1="570.5"
					x2="369.11"
					y2="570.5"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="373.46"
					y1="570.5"
					x2="378.35"
					y2="570.5"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="378.35"
					y1="570.5"
					x2="378.35"
					y2="577.87"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="303.71"
					y1="673.22"
					x2="487.76"
					y2="673.22"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="376.16"
					y1="627.9"
					x2="368.91"
					y2="627.9"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="364.55"
					y1="627.9"
					x2="357.3"
					y2="627.9"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="352.95"
					y1="627.9"
					x2="345.7"
					y2="627.9"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="303.71"
					y1="651.23"
					x2="303.71"
					y2="658.48"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="303.71"
					y1="662.83"
					x2="303.71"
					y2="670.2"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="303.71"
					y1="670.2"
					x2="306.54"
					y2="670.2"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="310.9"
					y1="670.2"
					x2="318.14"
					y2="670.2"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="322.5"
					y1="670.2"
					x2="329.75"
					y2="670.2"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="334.1"
					y1="670.2"
					x2="341.35"
					y2="670.2"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="345.7"
					y1="670.2"
					x2="352.95"
					y2="670.2"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="357.3"
					y1="670.2"
					x2="364.55"
					y2="670.2"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="368.91"
					y1="670.2"
					x2="376.16"
					y2="670.2"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="380.51"
					y1="670.2"
					x2="387.76"
					y2="670.2"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="392.11"
					y1="670.2"
					x2="399.36"
					y2="670.2"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="403.71"
					y1="670.2"
					x2="410.96"
					y2="670.2"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="415.31"
					y1="670.2"
					x2="422.56"
					y2="670.2"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="426.91"
					y1="670.2"
					x2="434.17"
					y2="670.2"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="438.52"
					y1="670.2"
					x2="445.77"
					y2="670.2"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="450.12"
					y1="670.2"
					x2="457.37"
					y2="670.2"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="461.72"
					y1="670.2"
					x2="468.97"
					y2="670.2"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="473.32"
					y1="670.2"
					x2="480.57"
					y2="670.2"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="484.92"
					y1="670.2"
					x2="487.76"
					y2="670.2"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="487.76"
					y1="670.2"
					x2="487.76"
					y2="662.83"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="487.76"
					y1="658.48"
					x2="487.76"
					y2="651.23"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="683.31"
					y1="803.78"
					x2="841"
					y2="803.78"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="841"
					y1="803.78"
					x2="841"
					y2="607.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="483.26 499.18 483.26 580.76 401.68 580.76 401.68 499.18 483.26 499.18"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="379.9 74.52 329.9 74.52 329.9 81.06 379.9 81.06 379.9 74.52"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="327.52 73.92 382.28 73.92 382.28 74.52 327.52 74.52 327.52 73.92"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="327.52"
					y1="73.92"
					x2="382.28"
					y2="73.92"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="382.28"
					y1="73.92"
					x2="382.28"
					y2="74.52"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="382.28"
					y1="74.52"
					x2="327.52"
					y2="74.52"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="327.52"
					y1="74.52"
					x2="327.52"
					y2="73.92"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="379.9"
					y1="81.06"
					x2="329.9"
					y2="81.06"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="329.9"
					y1="74.52"
					x2="379.9"
					y2="74.52"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="385.25 81.06 379.9 81.06 379.9 74.52 385.25 74.52 385.25 81.06"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="385.25"
					y1="81.06"
					x2="379.9"
					y2="81.06"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="379.9"
					y1="81.06"
					x2="379.9"
					y2="74.52"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="379.9"
					y1="74.52"
					x2="385.25"
					y2="74.52"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="385.25"
					y1="74.52"
					x2="385.25"
					y2="81.06"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="324.55 74.52 329.9 74.52 329.9 81.06 324.55 81.06 324.55 74.52"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="324.55"
					y1="74.52"
					x2="329.9"
					y2="74.52"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="329.9"
					y1="74.52"
					x2="329.9"
					y2="81.06"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="329.9"
					y1="81.06"
					x2="324.55"
					y2="81.06"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="324.55"
					y1="81.06"
					x2="324.55"
					y2="74.52"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="379.9"
					y1="75.71"
					x2="329.9"
					y2="75.71"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="387.63 80.46 385.25 80.46 385.25 74.52 382.28 74.52 382.28 73.92 387.63 73.92 387.63 80.46"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="387.63"
					y1="80.46"
					x2="385.25"
					y2="80.46"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="385.25"
					y1="80.46"
					x2="385.25"
					y2="74.52"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="385.25"
					y1="74.52"
					x2="382.28"
					y2="74.52"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="382.28"
					y1="74.52"
					x2="382.28"
					y2="73.92"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="382.28"
					y1="73.92"
					x2="387.63"
					y2="73.92"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="387.63"
					y1="73.92"
					x2="387.63"
					y2="80.46"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="322.17 73.92 327.52 73.92 327.52 74.52 324.55 74.52 324.55 80.46 322.17 80.46 322.17 73.92"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="322.17"
					y1="73.92"
					x2="327.52"
					y2="73.92"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="327.52"
					y1="73.92"
					x2="327.52"
					y2="74.52"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="327.52"
					y1="74.52"
					x2="324.55"
					y2="74.52"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="324.55"
					y1="74.52"
					x2="324.55"
					y2="80.46"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="324.55"
					y1="80.46"
					x2="322.17"
					y2="80.46"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="322.17"
					y1="80.46"
					x2="322.17"
					y2="73.92"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="319.15 75.71 319.15 78.73 194.4 78.73 194.4 75.71 319.15 75.71"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="319.15"
					y1="75.71"
					x2="319.15"
					y2="78.73"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="319.15"
					y1="78.73"
					x2="194.4"
					y2="78.73"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="194.4"
					y1="78.73"
					x2="194.4"
					y2="75.71"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="194.4"
					y1="75.71"
					x2="319.15"
					y2="75.71"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="387.63 75.71 393.67 75.71 393.67 93.83 387.63 93.83 387.63 75.71"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="393.67"
					y1="75.71"
					x2="387.63"
					y2="75.71"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="393.67"
					y1="93.83"
					x2="393.67"
					y2="75.71"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="387.63"
					y1="93.83"
					x2="393.67"
					y2="93.83"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="387.63"
					y1="75.71"
					x2="387.63"
					y2="93.83"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="316.13 75.71 322.17 75.71 322.17 93.83 316.13 93.83 316.13 75.71"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="322.17"
					y1="75.71"
					x2="316.13"
					y2="75.71"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="322.17"
					y1="93.83"
					x2="322.17"
					y2="75.71"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="316.13"
					y1="93.83"
					x2="322.17"
					y2="93.83"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="316.13"
					y1="75.71"
					x2="316.13"
					y2="93.83"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="191.38 75.71 197.43 75.71 197.43 93.83 191.38 93.83 191.38 75.71"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="197.43"
					y1="75.71"
					x2="191.38"
					y2="75.71"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="197.43"
					y1="93.83"
					x2="197.43"
					y2="75.71"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="191.38"
					y1="93.83"
					x2="197.43"
					y2="93.83"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="191.38"
					y1="75.71"
					x2="191.38"
					y2="93.83"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="832.85 74.52 782.85 74.52 782.85 81.06 832.85 81.06 832.85 74.52"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="780.47 73.92 835.23 73.92 835.23 74.52 780.47 74.52 780.47 73.92"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="780.47"
					y1="73.92"
					x2="835.23"
					y2="73.92"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="835.23"
					y1="73.92"
					x2="835.23"
					y2="74.52"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="835.23"
					y1="74.52"
					x2="780.47"
					y2="74.52"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="780.47"
					y1="74.52"
					x2="780.47"
					y2="73.92"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="832.85"
					y1="81.06"
					x2="782.85"
					y2="81.06"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="782.85"
					y1="74.52"
					x2="832.85"
					y2="74.52"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="838.2 81.06 832.85 81.06 832.85 74.52 838.2 74.52 838.2 81.06"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="838.2"
					y1="81.06"
					x2="832.85"
					y2="81.06"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="832.85"
					y1="81.06"
					x2="832.85"
					y2="74.52"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="832.85"
					y1="74.52"
					x2="838.2"
					y2="74.52"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="838.2"
					y1="74.52"
					x2="838.2"
					y2="81.06"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="777.5 74.52 782.85 74.52 782.85 81.06 777.5 81.06 777.5 74.52"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="777.5"
					y1="74.52"
					x2="782.85"
					y2="74.52"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="782.85"
					y1="74.52"
					x2="782.85"
					y2="81.06"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="782.85"
					y1="81.06"
					x2="777.5"
					y2="81.06"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="777.5"
					y1="81.06"
					x2="777.5"
					y2="74.52"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="832.85"
					y1="75.71"
					x2="782.85"
					y2="75.71"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="840.58 80.46 838.2 80.46 838.2 74.52 835.23 74.52 835.23 73.92 840.58 73.92 840.58 80.46"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="840.58"
					y1="80.46"
					x2="838.2"
					y2="80.46"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="838.2"
					y1="80.46"
					x2="838.2"
					y2="74.52"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="838.2"
					y1="74.52"
					x2="835.23"
					y2="74.52"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="835.23"
					y1="74.52"
					x2="835.23"
					y2="73.92"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="835.23"
					y1="73.92"
					x2="840.58"
					y2="73.92"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="840.58"
					y1="73.92"
					x2="840.58"
					y2="80.46"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="775.12 73.92 780.47 73.92 780.47 74.52 777.5 74.52 777.5 80.46 775.12 80.46 775.12 73.92"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="775.12"
					y1="73.92"
					x2="780.47"
					y2="73.92"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="780.47"
					y1="73.92"
					x2="780.47"
					y2="74.52"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="780.47"
					y1="74.52"
					x2="777.5"
					y2="74.52"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="777.5"
					y1="74.52"
					x2="777.5"
					y2="80.46"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="777.5"
					y1="80.46"
					x2="775.12"
					y2="80.46"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="775.12"
					y1="80.46"
					x2="775.12"
					y2="73.92"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="772.1 75.71 772.1 78.73 614.01 78.73 614.01 75.71 772.1 75.71"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="772.1"
					y1="75.71"
					x2="772.1"
					y2="78.73"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="772.1"
					y1="78.73"
					x2="614.01"
					y2="78.73"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="614.01"
					y1="78.73"
					x2="614.01"
					y2="75.71"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="614.01"
					y1="75.71"
					x2="772.1"
					y2="75.71"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="840.58 75.71 846.62 75.71 846.62 93.83 840.58 93.83 840.58 75.71"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="846.62"
					y1="75.71"
					x2="840.58"
					y2="75.71"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="846.62"
					y1="93.83"
					x2="846.62"
					y2="75.71"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="840.58"
					y1="93.83"
					x2="846.62"
					y2="93.83"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="840.58"
					y1="75.71"
					x2="840.58"
					y2="93.83"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="769.07 75.71 775.12 75.71 775.12 93.83 769.07 93.83 769.07 75.71"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="775.12"
					y1="75.71"
					x2="769.07"
					y2="75.71"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="775.12"
					y1="93.83"
					x2="775.12"
					y2="75.71"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="769.07"
					y1="93.83"
					x2="775.12"
					y2="93.83"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="769.07"
					y1="75.71"
					x2="769.07"
					y2="93.83"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="610.99 75.71 617.03 75.71 617.03 93.83 610.99 93.83 610.99 75.71"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="617.03"
					y1="75.71"
					x2="610.99"
					y2="75.71"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="617.03"
					y1="93.83"
					x2="617.03"
					y2="75.71"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="610.99"
					y1="93.83"
					x2="617.03"
					y2="93.83"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="610.99"
					y1="75.71"
					x2="610.99"
					y2="93.83"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="306.94"
					y1="928.83"
					x2="302.41"
					y2="928.83"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".39"
				/>
				<line
					x1="306.94"
					y1="904.66"
					x2="302.41"
					y2="904.66"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".39"
				/>
				<line
					x1="306.94"
					y1="904.66"
					x2="306.94"
					y2="928.83"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".39"
				/>
				<line
					x1="421.76"
					y1="928.83"
					x2="426.29"
					y2="928.83"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".39"
				/>
				<line
					x1="421.76"
					y1="904.66"
					x2="426.29"
					y2="904.66"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".39"
				/>
				<line
					x1="421.76"
					y1="904.66"
					x2="421.76"
					y2="928.83"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".39"
				/>
				<line
					x1="306.94"
					y1="904.66"
					x2="303.71"
					y2="904.66"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".39"
				/>
				<polyline
					points="420.24 930.34 426.28 930.34 426.28 928.83 420.24 928.83 420.24 930.34"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="308.45 928.83 302.41 928.83 302.41 930.34 308.45 930.34 308.45 928.83"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="420.24 904.66 426.28 904.66 426.28 903.14 420.24 903.14 420.24 904.66"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="308.45 903.14 302.41 903.14 302.41 904.66 308.45 904.66 308.45 903.14"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="420.24"
					y1="930.34"
					x2="426.29"
					y2="930.34"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="426.29"
					y1="930.34"
					x2="426.29"
					y2="928.83"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="426.29"
					y1="928.83"
					x2="420.24"
					y2="928.83"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="420.24"
					y1="928.83"
					x2="420.24"
					y2="930.34"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="308.45"
					y1="928.83"
					x2="302.41"
					y2="928.83"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="302.41"
					y1="928.83"
					x2="302.41"
					y2="930.34"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="302.41"
					y1="930.34"
					x2="308.45"
					y2="930.34"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="308.45"
					y1="930.34"
					x2="308.45"
					y2="928.83"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="420.24"
					y1="904.66"
					x2="426.29"
					y2="904.66"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="426.29"
					y1="904.66"
					x2="426.29"
					y2="903.14"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="426.29"
					y1="903.14"
					x2="420.24"
					y2="903.14"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="420.24"
					y1="903.14"
					x2="420.24"
					y2="904.66"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="308.45"
					y1="903.14"
					x2="302.41"
					y2="903.14"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="302.41"
					y1="903.14"
					x2="302.41"
					y2="904.66"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="302.41"
					y1="904.66"
					x2="308.45"
					y2="904.66"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="308.45"
					y1="904.66"
					x2="308.45"
					y2="903.14"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="418.73 928.83 421 928.83 421 904.66 418.73 904.66 418.73 928.83"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="307.7 928.83 309.97 928.83 309.97 904.66 307.7 904.66 307.7 928.83"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="386.88 827.75 309.97 904.66 313.7 908.39 390.62 831.48 386.88 827.75"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="421"
					y1="904.66"
					x2="421.76"
					y2="904.66"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="421"
					y1="928.83"
					x2="421.76"
					y2="928.83"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="421.76"
					y1="904.66"
					x2="421.76"
					y2="928.83"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="307.7"
					y1="904.66"
					x2="306.94"
					y2="904.66"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="307.7"
					y1="928.83"
					x2="306.94"
					y2="928.83"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="306.94"
					y1="904.66"
					x2="306.94"
					y2="928.83"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="418.73"
					y1="928.83"
					x2="418.73"
					y2="904.66"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="418.73"
					y1="904.66"
					x2="421"
					y2="904.66"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="421"
					y1="904.66"
					x2="421"
					y2="928.83"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="421"
					y1="928.83"
					x2="418.73"
					y2="928.83"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="307.7"
					y1="928.83"
					x2="307.7"
					y2="904.66"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="307.7"
					y1="904.66"
					x2="309.97"
					y2="904.66"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="309.97"
					y1="904.66"
					x2="309.97"
					y2="928.83"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="309.97"
					y1="928.83"
					x2="307.7"
					y2="928.83"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="386.88"
					y1="827.75"
					x2="390.62"
					y2="831.48"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="390.62"
					y1="831.48"
					x2="313.7"
					y2="908.39"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="313.7"
					y1="908.39"
					x2="309.97"
					y2="904.66"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="309.97"
					y1="904.66"
					x2="386.88"
					y2="827.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="421.76"
					y1="904.66"
					x2="421.76"
					y2="928.83"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".39"
				/>
				<line
					x1="421.76"
					y1="904.66"
					x2="421.76"
					y2="928.83"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".39"
				/>
				<line
					x1="421.76"
					y1="904.66"
					x2="426.29"
					y2="904.66"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".39"
				/>
				<line
					x1="421.76"
					y1="904.66"
					x2="426.29"
					y2="904.66"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".39"
				/>
				<line
					x1="421.76"
					y1="928.83"
					x2="426.29"
					y2="928.83"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".39"
				/>
				<line
					x1="421.76"
					y1="928.83"
					x2="426.29"
					y2="928.83"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".39"
				/>
				<line
					x1="306.94"
					y1="904.66"
					x2="306.94"
					y2="928.83"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".39"
				/>
				<line
					x1="306.94"
					y1="904.66"
					x2="306.94"
					y2="928.83"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".39"
				/>
				<line
					x1="306.94"
					y1="904.66"
					x2="302.41"
					y2="904.66"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".39"
				/>
				<line
					x1="306.94"
					y1="904.66"
					x2="302.41"
					y2="904.66"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".39"
				/>
				<line
					x1="306.94"
					y1="928.83"
					x2="302.41"
					y2="928.83"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".39"
				/>
				<line
					x1="306.94"
					y1="928.83"
					x2="302.41"
					y2="928.83"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".39"
				/>
				<line
					x1="846.62"
					y1="69.66"
					x2="846.62"
					y2="93.83"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".39"
				/>
				<line
					x1="111.85"
					y1="717.88"
					x2="111.85"
					y2="627.9"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".39"
				/>
				<line
					x1="88.23"
					y1="717.88"
					x2="111.85"
					y2="717.88"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".39"
				/>
				<line
					x1="502.86"
					y1="459.07"
					x2="502.86"
					y2="463.61"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".39"
				/>
				<line
					x1="487.76"
					y1="459.07"
					x2="487.76"
					y2="463.61"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".39"
				/>
				<line
					x1="487.76"
					y1="459.07"
					x2="502.86"
					y2="459.07"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".39"
				/>
				<line
					x1="502.86"
					y1="362.39"
					x2="502.86"
					y2="357.86"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".39"
				/>
				<line
					x1="487.76"
					y1="362.39"
					x2="487.76"
					y2="357.86"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".39"
				/>
				<line
					x1="487.76"
					y1="362.39"
					x2="502.86"
					y2="362.39"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".39"
				/>
				<line
					x1="487.76"
					y1="496.16"
					x2="487.76"
					y2="491.63"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".39"
				/>
				<line
					x1="502.86"
					y1="496.16"
					x2="502.86"
					y2="491.63"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".39"
				/>
				<line
					x1="502.86"
					y1="496.16"
					x2="487.76"
					y2="496.16"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".39"
				/>
				<line
					x1="502.86"
					y1="583.78"
					x2="487.76"
					y2="583.78"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".39"
				/>
				<line
					x1="502.86"
					y1="496.16"
					x2="502.86"
					y2="459.07"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".39"
				/>
				<line
					x1="487.76"
					y1="459.07"
					x2="487.76"
					y2="477.55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".39"
				/>
				<line
					x1="487.76"
					y1="492.66"
					x2="487.76"
					y2="496.16"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".39"
				/>
				<line
					x1="487.76"
					y1="583.78"
					x2="487.76"
					y2="587.28"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".39"
				/>
				<polyline
					points="504.37 363.9 504.37 357.86 502.86 357.86 502.86 363.9 504.37 363.9"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="502.86 457.56 502.86 463.61 504.37 463.61 504.37 457.56 502.86 457.56"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="487.76 363.9 487.76 357.86 486.24 357.86 486.24 363.9 487.76 363.9"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="486.24 457.56 486.24 463.61 487.76 463.61 487.76 457.56 486.24 457.56"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="504.37"
					y1="363.9"
					x2="504.37"
					y2="357.86"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="504.37"
					y1="357.86"
					x2="502.86"
					y2="357.86"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="502.86"
					y1="357.86"
					x2="502.86"
					y2="363.9"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="502.86"
					y1="363.9"
					x2="504.37"
					y2="363.9"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="502.86"
					y1="457.56"
					x2="502.86"
					y2="463.61"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="502.86"
					y1="463.61"
					x2="504.37"
					y2="463.61"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="504.37"
					y1="463.61"
					x2="504.37"
					y2="457.56"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="504.37"
					y1="457.56"
					x2="502.86"
					y2="457.56"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="487.76"
					y1="363.9"
					x2="487.76"
					y2="357.86"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="487.76"
					y1="357.86"
					x2="486.24"
					y2="357.86"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="486.24"
					y1="357.86"
					x2="486.24"
					y2="363.9"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="486.24"
					y1="363.9"
					x2="487.76"
					y2="363.9"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="486.24"
					y1="457.56"
					x2="486.24"
					y2="463.61"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="486.24"
					y1="463.61"
					x2="487.76"
					y2="463.61"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="487.76"
					y1="463.61"
					x2="487.76"
					y2="457.56"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="487.76"
					y1="457.56"
					x2="486.24"
					y2="457.56"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="502.86 365.41 502.86 363.15 487.76 363.15 487.76 365.41 502.86 365.41"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="502.86 458.32 502.86 456.05 487.76 456.05 487.76 458.32 502.86 458.32"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="423.66 391.96 487.76 456.05 491.49 452.32 427.4 388.22 423.66 391.96"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="487.76"
					y1="363.15"
					x2="487.76"
					y2="362.39"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="502.86"
					y1="363.15"
					x2="502.86"
					y2="362.39"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="487.76"
					y1="362.39"
					x2="502.86"
					y2="362.39"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="487.76"
					y1="458.32"
					x2="487.76"
					y2="459.07"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="502.86"
					y1="458.32"
					x2="502.86"
					y2="459.07"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="487.76"
					y1="459.07"
					x2="502.86"
					y2="459.07"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="502.86"
					y1="365.41"
					x2="487.76"
					y2="365.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="487.76"
					y1="365.41"
					x2="487.76"
					y2="363.15"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="487.76"
					y1="363.15"
					x2="502.86"
					y2="363.15"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="502.86"
					y1="363.15"
					x2="502.86"
					y2="365.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="502.86"
					y1="458.32"
					x2="487.76"
					y2="458.32"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="487.76"
					y1="458.32"
					x2="487.76"
					y2="456.05"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="487.76"
					y1="456.05"
					x2="502.86"
					y2="456.05"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="502.86"
					y1="456.05"
					x2="502.86"
					y2="458.32"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="423.66"
					y1="391.96"
					x2="427.4"
					y2="388.22"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="427.4"
					y1="388.22"
					x2="491.49"
					y2="452.32"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="491.49"
					y1="452.32"
					x2="487.76"
					y2="456.05"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="487.76"
					y1="456.05"
					x2="423.66"
					y2="391.96"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="487.76"
					y1="362.39"
					x2="502.86"
					y2="362.39"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".39"
				/>
				<line
					x1="487.76"
					y1="362.39"
					x2="502.86"
					y2="362.39"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".39"
				/>
				<line
					x1="487.76"
					y1="362.39"
					x2="487.76"
					y2="357.86"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".39"
				/>
				<line
					x1="487.76"
					y1="362.39"
					x2="487.76"
					y2="357.86"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".39"
				/>
				<line
					x1="502.86"
					y1="362.39"
					x2="502.86"
					y2="357.86"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".39"
				/>
				<line
					x1="502.86"
					y1="362.39"
					x2="502.86"
					y2="357.86"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".39"
				/>
				<line
					x1="487.76"
					y1="459.07"
					x2="502.86"
					y2="459.07"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".39"
				/>
				<line
					x1="487.76"
					y1="459.07"
					x2="502.86"
					y2="459.07"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".39"
				/>
				<line
					x1="487.76"
					y1="459.07"
					x2="487.76"
					y2="463.61"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".39"
				/>
				<line
					x1="487.76"
					y1="459.07"
					x2="487.76"
					y2="463.61"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".39"
				/>
				<line
					x1="502.86"
					y1="459.07"
					x2="502.86"
					y2="463.61"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".39"
				/>
				<line
					x1="502.86"
					y1="459.07"
					x2="502.86"
					y2="463.61"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".39"
				/>
				<polyline
					points="487.76 497.67 487.76 491.63 486.24 491.63 486.24 497.67 487.76 497.67"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="504.37 497.67 504.37 491.63 502.86 491.63 502.86 497.67 504.37 497.67"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="487.76"
					y1="582.27"
					x2="486.24"
					y2="582.27"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="487.76"
					y1="497.67"
					x2="487.76"
					y2="491.63"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="487.76"
					y1="491.63"
					x2="486.24"
					y2="491.63"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="486.24"
					y1="491.63"
					x2="486.24"
					y2="497.67"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="486.24"
					y1="497.67"
					x2="487.76"
					y2="497.67"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="504.37"
					y1="582.27"
					x2="502.86"
					y2="582.27"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="504.37"
					y1="497.67"
					x2="504.37"
					y2="491.63"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="504.37"
					y1="491.63"
					x2="502.86"
					y2="491.63"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="502.86"
					y1="491.63"
					x2="502.86"
					y2="497.67"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="502.86"
					y1="497.67"
					x2="504.37"
					y2="497.67"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="487.76 580.76 487.76 583.02 502.86 583.02 502.86 580.76 487.76 580.76"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="487.76 496.91 487.76 499.18 502.86 499.18 502.86 496.91 487.76 496.91"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="560.54 556.86 502.86 499.18 499.12 502.92 556.8 560.6 560.54 556.86"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="502.86"
					y1="583.02"
					x2="502.86"
					y2="583.78"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="487.76"
					y1="583.02"
					x2="487.76"
					y2="583.78"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="502.86"
					y1="583.78"
					x2="487.76"
					y2="583.78"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="502.86"
					y1="496.91"
					x2="502.86"
					y2="496.16"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="487.76"
					y1="496.91"
					x2="487.76"
					y2="496.16"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="502.86"
					y1="496.16"
					x2="487.76"
					y2="496.16"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="487.76"
					y1="580.76"
					x2="502.86"
					y2="580.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="502.86"
					y1="580.76"
					x2="502.86"
					y2="583.02"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="502.86"
					y1="583.02"
					x2="487.76"
					y2="583.02"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="487.76"
					y1="583.02"
					x2="487.76"
					y2="580.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="487.76"
					y1="496.91"
					x2="502.86"
					y2="496.91"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="502.86"
					y1="496.91"
					x2="502.86"
					y2="499.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="502.86"
					y1="499.18"
					x2="487.76"
					y2="499.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="487.76"
					y1="499.18"
					x2="487.76"
					y2="496.91"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="560.54"
					y1="556.86"
					x2="556.8"
					y2="560.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="556.8"
					y1="560.6"
					x2="499.12"
					y2="502.92"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="499.12"
					y1="502.92"
					x2="502.86"
					y2="499.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="502.86"
					y1="499.18"
					x2="560.54"
					y2="556.86"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="502.86"
					y1="583.78"
					x2="487.76"
					y2="583.78"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".39"
				/>
				<line
					x1="502.86"
					y1="583.78"
					x2="487.76"
					y2="583.78"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".39"
				/>
				<line
					x1="502.86"
					y1="496.16"
					x2="487.76"
					y2="496.16"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".39"
				/>
				<line
					x1="502.86"
					y1="496.16"
					x2="487.76"
					y2="496.16"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".39"
				/>
				<line
					x1="502.86"
					y1="496.16"
					x2="502.86"
					y2="491.63"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".39"
				/>
				<line
					x1="502.86"
					y1="496.16"
					x2="502.86"
					y2="491.63"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".39"
				/>
				<line
					x1="487.76"
					y1="496.16"
					x2="487.76"
					y2="491.63"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".39"
				/>
				<line
					x1="487.76"
					y1="496.16"
					x2="487.76"
					y2="491.63"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".39"
				/>
				<line
					x1="329.91"
					y1="546.18"
					x2="333.69"
					y2="546.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".39"
				/>
				<line
					x1="329.91"
					y1="543.16"
					x2="329.91"
					y2="546.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".39"
				/>
				<line
					x1="329.91"
					y1="531.07"
					x2="333.69"
					y2="531.07"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".39"
				/>
				<line
					x1="329.91"
					y1="531.07"
					x2="329.91"
					y2="543.16"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".39"
				/>
				<line
					x1="114.52"
					y1="546.18"
					x2="110.75"
					y2="546.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".39"
				/>
				<line
					x1="114.52"
					y1="543.16"
					x2="114.52"
					y2="546.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".39"
				/>
				<line
					x1="114.52"
					y1="531.07"
					x2="110.75"
					y2="531.07"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".39"
				/>
				<line
					x1="114.52"
					y1="531.07"
					x2="114.52"
					y2="543.16"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".39"
				/>
				<polyline
					points="116.79 543.16 115.28 543.16 115.28 546.18 116.79 546.18 116.79 543.16"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="116.79 547.69 116.79 546.18 110.75 546.18 110.75 547.69 116.79 547.69"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="329.16 543.16 327.65 543.16 327.65 546.18 329.16 546.18 329.16 543.16"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="327.65 546.18 327.65 547.69 333.69 547.69 333.69 546.18 327.65 546.18"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="116.79 531.07 116.79 527.29 110.75 527.29 110.75 531.07 116.79 531.07"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="327.65 527.29 327.65 531.07 333.69 531.07 333.69 527.29 327.65 527.29"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="116.79"
					y1="543.16"
					x2="116.79"
					y2="546.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="116.79"
					y1="546.18"
					x2="115.28"
					y2="546.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="115.28"
					y1="546.18"
					x2="115.28"
					y2="543.16"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="115.28"
					y1="543.16"
					x2="116.79"
					y2="543.16"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="116.79"
					y1="547.69"
					x2="110.75"
					y2="547.69"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="110.75"
					y1="547.69"
					x2="110.75"
					y2="546.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="110.75"
					y1="546.18"
					x2="116.79"
					y2="546.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="116.79"
					y1="546.18"
					x2="116.79"
					y2="547.69"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="329.16"
					y1="543.16"
					x2="329.16"
					y2="546.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="329.16"
					y1="546.18"
					x2="327.65"
					y2="546.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="327.65"
					y1="546.18"
					x2="327.65"
					y2="543.16"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="327.65"
					y1="543.16"
					x2="329.16"
					y2="543.16"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="327.65"
					y1="546.18"
					x2="333.69"
					y2="546.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="333.69"
					y1="546.18"
					x2="333.69"
					y2="547.69"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="333.69"
					y1="547.69"
					x2="327.65"
					y2="547.69"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="327.65"
					y1="547.69"
					x2="327.65"
					y2="546.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="116.79"
					y1="531.07"
					x2="110.75"
					y2="531.07"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="110.75"
					y1="531.07"
					x2="110.75"
					y2="527.29"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="110.75"
					y1="527.29"
					x2="116.79"
					y2="527.29"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="116.79"
					y1="527.29"
					x2="116.79"
					y2="531.07"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="327.65"
					y1="527.29"
					x2="333.69"
					y2="527.29"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="333.69"
					y1="527.29"
					x2="333.69"
					y2="531.07"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="333.69"
					y1="531.07"
					x2="327.65"
					y2="531.07"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="327.65"
					y1="531.07"
					x2="327.65"
					y2="527.29"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="121.32 543.16 121.32 531.07 115.28 531.07 115.28 543.16 121.32 543.16"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="329.16 543.16 329.16 531.07 323.11 531.07 323.11 543.16 329.16 543.16"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="219.2 531.07 219.2 536.36 323.11 536.36 323.11 531.07 219.2 531.07"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="157.58 536.36 157.58 541.65 261.49 541.65 261.49 536.36 157.58 536.36"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="115.28"
					y1="531.07"
					x2="114.52"
					y2="531.07"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="115.28"
					y1="543.16"
					x2="114.52"
					y2="543.16"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="114.52"
					y1="531.07"
					x2="114.52"
					y2="543.16"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="329.16"
					y1="531.07"
					x2="329.91"
					y2="531.07"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="329.16"
					y1="543.16"
					x2="329.91"
					y2="543.16"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="329.91"
					y1="531.07"
					x2="329.91"
					y2="543.16"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="121.32"
					y1="543.16"
					x2="121.32"
					y2="531.07"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="121.32"
					y1="531.07"
					x2="115.28"
					y2="531.07"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="115.28"
					y1="531.07"
					x2="115.28"
					y2="543.16"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="115.28"
					y1="543.16"
					x2="121.32"
					y2="543.16"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="329.16"
					y1="543.16"
					x2="329.16"
					y2="531.07"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="329.16"
					y1="531.07"
					x2="323.11"
					y2="531.07"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="323.11"
					y1="531.07"
					x2="323.11"
					y2="543.16"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="323.11"
					y1="543.16"
					x2="329.16"
					y2="543.16"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="219.2"
					y1="531.07"
					x2="219.2"
					y2="536.36"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="219.2"
					y1="536.36"
					x2="323.11"
					y2="536.36"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="323.11"
					y1="536.36"
					x2="323.11"
					y2="531.07"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="323.11"
					y1="531.07"
					x2="219.2"
					y2="531.07"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="157.58"
					y1="536.36"
					x2="157.58"
					y2="541.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="157.58"
					y1="541.65"
					x2="261.49"
					y2="541.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="261.49"
					y1="541.65"
					x2="261.49"
					y2="536.36"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="261.49"
					y1="536.36"
					x2="157.58"
					y2="536.36"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="114.52"
					y1="531.07"
					x2="114.52"
					y2="543.16"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".39"
				/>
				<line
					x1="114.52"
					y1="531.07"
					x2="114.52"
					y2="543.16"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".39"
				/>
				<line
					x1="114.52"
					y1="543.16"
					x2="114.52"
					y2="546.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".39"
				/>
				<line
					x1="114.52"
					y1="531.07"
					x2="110.75"
					y2="531.07"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".39"
				/>
				<line
					x1="114.52"
					y1="543.16"
					x2="114.52"
					y2="546.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".39"
				/>
				<line
					x1="114.52"
					y1="546.18"
					x2="110.75"
					y2="546.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".39"
				/>
				<line
					x1="114.52"
					y1="546.18"
					x2="110.75"
					y2="546.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".39"
				/>
				<line
					x1="329.91"
					y1="531.07"
					x2="329.91"
					y2="543.16"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".39"
				/>
				<line
					x1="329.91"
					y1="531.07"
					x2="329.91"
					y2="543.16"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".39"
				/>
				<line
					x1="329.91"
					y1="543.16"
					x2="329.91"
					y2="546.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".39"
				/>
				<line
					x1="329.91"
					y1="531.07"
					x2="333.69"
					y2="531.07"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".39"
				/>
				<line
					x1="329.91"
					y1="543.16"
					x2="329.91"
					y2="546.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".39"
				/>
				<line
					x1="329.91"
					y1="546.18"
					x2="333.69"
					y2="546.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".39"
				/>
				<line
					x1="329.91"
					y1="546.18"
					x2="333.69"
					y2="546.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".39"
				/>
				<line
					x1="487.76"
					y1="587.28"
					x2="393.46"
					y2="587.28"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".39"
				/>
				<line
					x1="345.34"
					y1="700.76"
					x2="340.8"
					y2="700.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".39"
				/>
				<line
					x1="345.34"
					y1="715.86"
					x2="340.8"
					y2="715.86"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".39"
				/>
				<line
					x1="345.34"
					y1="715.86"
					x2="345.34"
					y2="700.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".39"
				/>
				<line
					x1="442.02"
					y1="700.76"
					x2="446.55"
					y2="700.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".39"
				/>
				<line
					x1="442.02"
					y1="715.86"
					x2="446.55"
					y2="715.86"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".39"
				/>
				<line
					x1="442.02"
					y1="715.86"
					x2="442.02"
					y2="700.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".39"
				/>
				<polyline
					points="440.51 699.25 440.51 700.76 446.55 700.76 446.55 699.25 440.51 699.25"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="346.85 700.76 346.85 699.25 340.8 699.25 340.8 700.76 346.85 700.76"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="440.51 715.86 440.51 717.37 446.55 717.37 446.55 715.86 440.51 715.86"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="346.85 717.37 346.85 715.86 340.8 715.86 340.8 717.37 346.85 717.37"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="440.51"
					y1="699.25"
					x2="446.55"
					y2="699.25"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="446.55"
					y1="699.25"
					x2="446.55"
					y2="700.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="446.55"
					y1="700.76"
					x2="440.51"
					y2="700.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="440.51"
					y1="700.76"
					x2="440.51"
					y2="699.25"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="346.85"
					y1="700.76"
					x2="340.8"
					y2="700.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="340.8"
					y1="700.76"
					x2="340.8"
					y2="699.25"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="340.8"
					y1="699.25"
					x2="346.85"
					y2="699.25"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="346.85"
					y1="699.25"
					x2="346.85"
					y2="700.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="440.51"
					y1="715.86"
					x2="446.55"
					y2="715.86"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="446.55"
					y1="715.86"
					x2="446.55"
					y2="717.37"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="446.55"
					y1="717.37"
					x2="440.51"
					y2="717.37"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="440.51"
					y1="717.37"
					x2="440.51"
					y2="715.86"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="346.85"
					y1="717.37"
					x2="340.8"
					y2="717.37"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="340.8"
					y1="717.37"
					x2="340.8"
					y2="715.86"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="340.8"
					y1="715.86"
					x2="346.85"
					y2="715.86"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="346.85"
					y1="715.86"
					x2="346.85"
					y2="717.37"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="439 700.76 439 715.86 441.26 715.86 441.26 700.76 439 700.76"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="346.09 700.76 346.09 715.86 348.36 715.86 348.36 700.76 346.09 700.76"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="412.45 779.96 416.19 776.22 352.1 712.12 348.36 715.86 412.45 779.96"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="441.26"
					y1="715.86"
					x2="442.02"
					y2="715.86"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="441.26"
					y1="700.76"
					x2="442.02"
					y2="700.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="442.02"
					y1="715.86"
					x2="442.02"
					y2="700.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="346.09"
					y1="715.86"
					x2="345.34"
					y2="715.86"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="346.09"
					y1="700.76"
					x2="345.34"
					y2="700.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="345.34"
					y1="715.86"
					x2="345.34"
					y2="700.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="439"
					y1="700.76"
					x2="439"
					y2="715.86"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="439"
					y1="715.86"
					x2="441.26"
					y2="715.86"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="441.26"
					y1="715.86"
					x2="441.26"
					y2="700.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="441.26"
					y1="700.76"
					x2="439"
					y2="700.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="346.09"
					y1="700.76"
					x2="346.09"
					y2="715.86"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="346.09"
					y1="715.86"
					x2="348.36"
					y2="715.86"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="348.36"
					y1="715.86"
					x2="348.36"
					y2="700.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="348.36"
					y1="700.76"
					x2="346.09"
					y2="700.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="412.45"
					y1="779.96"
					x2="416.19"
					y2="776.22"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="416.19"
					y1="776.22"
					x2="352.1"
					y2="712.12"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="352.1"
					y1="712.12"
					x2="348.36"
					y2="715.86"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="348.36"
					y1="715.86"
					x2="412.45"
					y2="779.96"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="442.02"
					y1="715.86"
					x2="442.02"
					y2="700.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".39"
				/>
				<line
					x1="442.02"
					y1="715.86"
					x2="442.02"
					y2="700.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".39"
				/>
				<line
					x1="442.02"
					y1="715.86"
					x2="446.55"
					y2="715.86"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".39"
				/>
				<line
					x1="442.02"
					y1="715.86"
					x2="446.55"
					y2="715.86"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".39"
				/>
				<line
					x1="442.02"
					y1="700.76"
					x2="446.55"
					y2="700.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".39"
				/>
				<line
					x1="442.02"
					y1="700.76"
					x2="446.55"
					y2="700.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".39"
				/>
				<line
					x1="345.34"
					y1="715.86"
					x2="345.34"
					y2="700.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".39"
				/>
				<line
					x1="345.34"
					y1="715.86"
					x2="345.34"
					y2="700.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".39"
				/>
				<line
					x1="345.34"
					y1="715.86"
					x2="340.8"
					y2="715.86"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".39"
				/>
				<line
					x1="345.34"
					y1="715.86"
					x2="340.8"
					y2="715.86"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".39"
				/>
				<line
					x1="345.34"
					y1="700.76"
					x2="340.8"
					y2="700.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".39"
				/>
				<line
					x1="345.34"
					y1="700.76"
					x2="340.8"
					y2="700.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".39"
				/>
				<line
					x1="303.71"
					y1="894.64"
					x2="303.71"
					y2="899.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".39"
				/>
				<line
					x1="288.61"
					y1="894.64"
					x2="288.61"
					y2="899.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".39"
				/>
				<line
					x1="288.61"
					y1="894.64"
					x2="303.71"
					y2="894.64"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".39"
				/>
				<line
					x1="303.71"
					y1="797.96"
					x2="303.71"
					y2="793.43"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".39"
				/>
				<line
					x1="288.61"
					y1="797.96"
					x2="288.61"
					y2="793.43"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".39"
				/>
				<line
					x1="288.61"
					y1="797.96"
					x2="303.71"
					y2="797.96"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".39"
				/>
				<line
					x1="303.71"
					y1="904.66"
					x2="303.71"
					y2="894.64"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".39"
				/>
				<line
					x1="288.61"
					y1="894.64"
					x2="288.61"
					y2="904.66"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".39"
				/>
				<polyline
					points="305.22 799.47 305.22 793.43 303.71 793.43 303.71 799.47 305.22 799.47"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="303.71 893.13 303.71 899.18 305.22 899.18 305.22 893.13 303.71 893.13"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="288.61 799.47 288.61 793.43 287.09 793.43 287.09 799.47 288.61 799.47"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="287.09 893.13 287.09 899.18 288.61 899.18 288.61 893.13 287.09 893.13"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="305.22"
					y1="799.47"
					x2="305.22"
					y2="793.43"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="305.22"
					y1="793.43"
					x2="303.71"
					y2="793.43"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="303.71"
					y1="793.43"
					x2="303.71"
					y2="799.47"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="303.71"
					y1="799.47"
					x2="305.22"
					y2="799.47"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="303.71"
					y1="893.13"
					x2="303.71"
					y2="899.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="303.71"
					y1="899.18"
					x2="305.22"
					y2="899.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="305.22"
					y1="899.18"
					x2="305.22"
					y2="893.13"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="305.22"
					y1="893.13"
					x2="303.71"
					y2="893.13"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="288.61"
					y1="799.47"
					x2="288.61"
					y2="793.43"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="288.61"
					y1="793.43"
					x2="287.09"
					y2="793.43"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="287.09"
					y1="793.43"
					x2="287.09"
					y2="799.47"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="287.09"
					y1="799.47"
					x2="288.61"
					y2="799.47"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="287.09"
					y1="893.13"
					x2="287.09"
					y2="899.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="287.09"
					y1="899.18"
					x2="288.61"
					y2="899.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="288.61"
					y1="899.18"
					x2="288.61"
					y2="893.13"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="288.61"
					y1="893.13"
					x2="287.09"
					y2="893.13"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="303.71 800.98 303.71 798.72 288.61 798.72 288.61 800.98 303.71 800.98"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="303.71 893.89 303.71 891.62 288.61 891.62 288.61 893.89 303.71 893.89"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="224.51 827.53 288.61 891.62 292.34 887.88 228.25 823.79 224.51 827.53"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="288.61"
					y1="798.72"
					x2="288.61"
					y2="797.96"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="303.71"
					y1="798.72"
					x2="303.71"
					y2="797.96"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="288.61"
					y1="797.96"
					x2="303.71"
					y2="797.96"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="288.61"
					y1="893.89"
					x2="288.61"
					y2="894.64"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="303.71"
					y1="893.89"
					x2="303.71"
					y2="894.64"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="288.61"
					y1="894.64"
					x2="303.71"
					y2="894.64"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="303.71"
					y1="800.98"
					x2="288.61"
					y2="800.98"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="288.61"
					y1="800.98"
					x2="288.61"
					y2="798.72"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="288.61"
					y1="798.72"
					x2="303.71"
					y2="798.72"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="303.71"
					y1="798.72"
					x2="303.71"
					y2="800.98"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="303.71"
					y1="893.89"
					x2="288.61"
					y2="893.89"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="288.61"
					y1="893.89"
					x2="288.61"
					y2="891.62"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="288.61"
					y1="891.62"
					x2="303.71"
					y2="891.62"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="303.71"
					y1="891.62"
					x2="303.71"
					y2="893.89"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="224.51"
					y1="827.53"
					x2="228.25"
					y2="823.79"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="228.25"
					y1="823.79"
					x2="292.34"
					y2="887.88"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="292.34"
					y1="887.88"
					x2="288.61"
					y2="891.62"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="288.61"
					y1="891.62"
					x2="224.51"
					y2="827.53"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="288.61"
					y1="797.96"
					x2="303.71"
					y2="797.96"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".39"
				/>
				<line
					x1="288.61"
					y1="797.96"
					x2="303.71"
					y2="797.96"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".39"
				/>
				<line
					x1="288.61"
					y1="797.96"
					x2="288.61"
					y2="793.43"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".39"
				/>
				<line
					x1="288.61"
					y1="797.96"
					x2="288.61"
					y2="793.43"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".39"
				/>
				<line
					x1="303.71"
					y1="797.96"
					x2="303.71"
					y2="793.43"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".39"
				/>
				<line
					x1="303.71"
					y1="797.96"
					x2="303.71"
					y2="793.43"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".39"
				/>
				<line
					x1="288.61"
					y1="894.64"
					x2="303.71"
					y2="894.64"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".39"
				/>
				<line
					x1="288.61"
					y1="894.64"
					x2="303.71"
					y2="894.64"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".39"
				/>
				<line
					x1="288.61"
					y1="894.64"
					x2="288.61"
					y2="899.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".39"
				/>
				<line
					x1="288.61"
					y1="894.64"
					x2="288.61"
					y2="899.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".39"
				/>
				<line
					x1="303.71"
					y1="894.64"
					x2="303.71"
					y2="899.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".39"
				/>
				<line
					x1="303.71"
					y1="894.64"
					x2="303.71"
					y2="899.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".39"
				/>
				<line
					x1="683.31"
					y1="876.29"
					x2="683.31"
					y2="904.66"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".39"
				/>
				<line
					x1="191.38"
					y1="93.83"
					x2="191.38"
					y2="69.66"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".39"
				/>
				<line
					x1="393.67"
					y1="69.66"
					x2="393.67"
					y2="93.83"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".39"
				/>
				<line
					x1="610.99"
					y1="93.83"
					x2="610.99"
					y2="69.66"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".39"
				/>
				<polyline
					points="148.63 795.15 148.63 717.88 88.23 717.88 88.23 795.15 148.63 795.15"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="148.63"
					y1="795.15"
					x2="148.63"
					y2="717.88"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="88.23"
					y1="795.15"
					x2="88.23"
					y2="717.88"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="148.63"
					y1="717.88"
					x2="88.23"
					y2="717.88"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="148.63"
					y1="795.15"
					x2="88.23"
					y2="795.15"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="90.61"
					y1="795.15"
					x2="90.61"
					y2="717.88"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="134.29"
					y1="786.73"
					x2="134.29"
					y2="726.3"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="134.29"
					y1="726.3"
					x2="98.04"
					y2="726.3"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="98.04"
					y1="726.3"
					x2="98.04"
					y2="786.73"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="98.04"
					y1="786.73"
					x2="134.29"
					y2="786.73"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="136.67"
					y1="789.11"
					x2="136.67"
					y2="723.92"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="136.67"
					y1="723.92"
					x2="95.66"
					y2="723.92"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="95.66"
					y1="723.92"
					x2="95.66"
					y2="789.11"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="95.66"
					y1="789.11"
					x2="136.67"
					y2="789.11"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m109.79,756.51c0-1.97-1.6-3.57-3.57-3.57s-3.57,1.6-3.57,3.57,1.6,3.57,3.57,3.57,3.57-1.6,3.57-3.57"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="91.49 759.49 96.48 759.01 97.62 758.62 103.91 757.84 104.74 757.39 105.08 756.51 104.74 755.64 103.91 755.19 97.62 754.41 96.48 754.02 91.49 753.54 89.75 754.11 88.67 755.6 88.67 757.43 89.75 758.92 91.49 759.49"
					fill="none"
					fillRule="evenodd"
				/>
				<path
					d="m91.49,759.49c-1.64,0-2.97-1.33-2.97-2.98s1.33-2.97,2.97-2.97"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="96.48"
					y1="754.02"
					x2="91.49"
					y2="753.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m96.48,754.02c.4.04.79.17,1.13.39"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="103.91"
					y1="755.19"
					x2="97.62"
					y2="754.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m103.91,755.19c.67.09,1.17.65,1.17,1.32s-.5,1.24-1.17,1.32"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="97.62"
					y1="758.62"
					x2="103.91"
					y2="757.84"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m97.62,758.62c-.34.22-.73.35-1.13.39"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="91.49"
					y1="759.49"
					x2="96.48"
					y2="759.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="94.46"
					y1="754.9"
					x2="96.23"
					y2="754.9"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="96.23"
					y1="758.13"
					x2="94.46"
					y2="758.13"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="94.46"
					y1="758.13"
					x2="94.46"
					y2="754.9"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m96.23,754.9c.89,0,1.62.72,1.62,1.62s-.72,1.62-1.62,1.62"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m97.62,754.41c.72.46,1.15,1.26,1.15,2.11s-.43,1.65-1.15,2.11"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="167.57 834.98 164.52 831.42 160.69 828.73 156.3 826.73 151.7 825.3 144.2 824.1 136.63 824.56 129.34 826.67 122.76 826.51 116.4 824.84 110.59 821.75 104.65 818.57 100.88 817.94 100.15 817.94 95.57 819.13 91.74 821.91 89.18 825.88 88.23 830.52 88.23 861.9 89.19 866.59 91.67 870.68 88.99 870.68 88.99 873.13 94.86 873.13 97.06 874 102.64 874.29 107.89 872.37 110.45 870.75 116.33 867.64 122.76 865.96 129.41 865.78 136.68 867.87 144.23 868.33 151.7 867.12 156.3 865.69 160.69 863.69 164.52 861 167.57 857.45 169.98 852.05 170.82 846.21 169.98 840.36 167.57 834.98"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="116.13"
					y1="857.39"
					x2="116.13"
					y2="835.03"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="88.23"
					y1="830.52"
					x2="88.23"
					y2="846.21"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="89.36"
					y1="830.52"
					x2="89.36"
					y2="846.21"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="88.23"
					y1="861.9"
					x2="88.23"
					y2="846.21"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="89.36"
					y1="861.9"
					x2="89.36"
					y2="846.21"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="116.13"
					y1="835.61"
					x2="111.95"
					y2="835.61"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="111.95"
					y1="835.61"
					x2="111.95"
					y2="839.06"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="111.95"
					y1="839.06"
					x2="116.13"
					y2="839.06"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="116.13"
					y1="856.81"
					x2="111.95"
					y2="856.81"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="111.95"
					y1="856.81"
					x2="111.95"
					y2="853.36"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="111.95"
					y1="853.36"
					x2="116.13"
					y2="853.36"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="99.38"
					y1="870.68"
					x2="88.99"
					y2="870.68"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="99.38"
					y1="873.13"
					x2="88.99"
					y2="873.13"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="88.99"
					y1="873.13"
					x2="88.99"
					y2="870.68"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="99.38"
					y1="873.13"
					x2="99.38"
					y2="870.68"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="170.82"
					y1="846.21"
					x2="170.38"
					y2="842.46"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="170.38"
					y1="842.46"
					x2="169.42"
					y2="838.83"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="169.42"
					y1="838.83"
					x2="167.57"
					y2="834.98"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="167.57"
					y1="834.98"
					x2="164.52"
					y2="831.42"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="164.52"
					y1="831.42"
					x2="160.69"
					y2="828.73"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="160.69"
					y1="828.73"
					x2="156.33"
					y2="826.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="156.33"
					y1="826.74"
					x2="151.7"
					y2="825.3"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="151.7"
					y1="825.3"
					x2="147.98"
					y2="824.48"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="147.98"
					y1="824.48"
					x2="144.22"
					y2="824"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="144.22"
					y1="824"
					x2="140.44"
					y2="823.93"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="140.44"
					y1="823.93"
					x2="136.68"
					y2="824.36"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="136.68"
					y1="824.36"
					x2="130.85"
					y2="826.05"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="130.85"
					y1="826.05"
					x2="125.2"
					y2="828.7"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="125.2"
					y1="828.7"
					x2="120.16"
					y2="831.84"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="120.16"
					y1="831.84"
					x2="116.13"
					y2="835.03"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="129.34"
					y1="826.67"
					x2="124.1"
					y2="826.64"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="124.1"
					y1="826.64"
					x2="119"
					y2="825.77"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="119"
					y1="825.77"
					x2="116.26"
					y2="824.89"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="116.26"
					y1="824.89"
					x2="113.54"
					y2="823.61"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="113.54"
					y1="823.61"
					x2="109.58"
					y2="821.08"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="109.58"
					y1="821.08"
					x2="105.49"
					y2="818.86"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="105.49"
					y1="818.86"
					x2="101.49"
					y2="817.97"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="101.49"
					y1="817.97"
					x2="97.5"
					y2="818.31"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="97.5"
					y1="818.31"
					x2="95.62"
					y2="818.93"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="95.62"
					y1="818.93"
					x2="93.88"
					y2="819.86"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="93.88"
					y1="819.86"
					x2="92.31"
					y2="821.08"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="92.31"
					y1="821.08"
					x2="90.96"
					y2="822.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="90.96"
					y1="822.6"
					x2="89.48"
					y2="825.28"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="89.48"
					y1="825.28"
					x2="88.66"
					y2="827.84"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="88.66"
					y1="827.84"
					x2="88.23"
					y2="830.52"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="89.36"
					y1="830.52"
					x2="89.48"
					y2="829.32"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="89.48"
					y1="829.32"
					x2="90.24"
					y2="826.85"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="90.24"
					y1="826.85"
					x2="92.08"
					y2="824.67"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="92.08"
					y1="824.67"
					x2="94.64"
					y2="823.31"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="94.64"
					y1="823.31"
					x2="98.01"
					y2="822.66"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="98.01"
					y1="822.66"
					x2="101.48"
					y2="822.51"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="101.48"
					y1="822.51"
					x2="103.2"
					y2="822.53"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="103.2"
					y1="822.53"
					x2="104.57"
					y2="823.25"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="104.57"
					y1="823.25"
					x2="104.97"
					y2="824.11"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="104.97"
					y1="824.11"
					x2="107.67"
					y2="833.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="107.67"
					y1="833.6"
					x2="108.47"
					y2="838.32"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="108.47"
					y1="838.32"
					x2="108.82"
					y2="843.09"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="108.82"
					y1="843.09"
					x2="108.82"
					y2="846.21"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="129.41"
					y1="865.78"
					x2="124.16"
					y2="865.82"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="124.16"
					y1="865.82"
					x2="119.04"
					y2="866.68"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="119.04"
					y1="866.68"
					x2="116.28"
					y2="867.55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="116.28"
					y1="867.55"
					x2="113.54"
					y2="868.81"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="113.54"
					y1="868.81"
					x2="109.57"
					y2="871.32"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="109.57"
					y1="871.32"
					x2="105.49"
					y2="873.56"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="105.49"
					y1="873.56"
					x2="102.82"
					y2="874.29"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="102.82"
					y1="874.29"
					x2="100.07"
					y2="874.47"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="100.07"
					y1="874.47"
					x2="97.38"
					y2="874.08"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="97.38"
					y1="874.08"
					x2="94.86"
					y2="873.13"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="89.36"
					y1="861.9"
					x2="89.48"
					y2="863.1"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="89.48"
					y1="863.1"
					x2="90.24"
					y2="865.57"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="90.24"
					y1="865.57"
					x2="92.08"
					y2="867.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="92.08"
					y1="867.75"
					x2="94.64"
					y2="869.11"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="94.64"
					y1="869.11"
					x2="98.01"
					y2="869.77"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="98.01"
					y1="869.77"
					x2="101.48"
					y2="869.92"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="101.48"
					y1="869.92"
					x2="103.2"
					y2="869.89"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="103.2"
					y1="869.89"
					x2="104.57"
					y2="869.16"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="104.57"
					y1="869.16"
					x2="104.97"
					y2="868.32"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="104.97"
					y1="868.32"
					x2="107.67"
					y2="858.82"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="107.67"
					y1="858.82"
					x2="108.47"
					y2="854.1"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="108.47"
					y1="854.1"
					x2="108.82"
					y2="849.33"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="108.82"
					y1="849.33"
					x2="108.82"
					y2="846.21"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="170.82"
					y1="846.21"
					x2="170.38"
					y2="849.96"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="170.38"
					y1="849.96"
					x2="169.42"
					y2="853.59"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="169.42"
					y1="853.59"
					x2="167.57"
					y2="857.45"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="167.57"
					y1="857.45"
					x2="164.52"
					y2="861"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="164.52"
					y1="861"
					x2="160.69"
					y2="863.69"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="160.69"
					y1="863.69"
					x2="156.33"
					y2="865.68"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="156.33"
					y1="865.68"
					x2="151.7"
					y2="867.12"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="151.7"
					y1="867.12"
					x2="147.98"
					y2="867.94"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="147.98"
					y1="867.94"
					x2="144.22"
					y2="868.42"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="144.22"
					y1="868.42"
					x2="140.44"
					y2="868.49"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="140.44"
					y1="868.49"
					x2="136.68"
					y2="868.07"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="136.68"
					y1="868.07"
					x2="130.85"
					y2="866.37"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="130.85"
					y1="866.37"
					x2="125.2"
					y2="863.72"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="125.2"
					y1="863.72"
					x2="120.16"
					y2="860.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="120.16"
					y1="860.58"
					x2="116.13"
					y2="857.39"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="107.66"
					y1="819.91"
					x2="108.51"
					y2="820.51"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="108.51"
					y1="820.51"
					x2="109.79"
					y2="822.24"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="109.79"
					y1="822.24"
					x2="110.09"
					y2="823.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="110.09"
					y1="823.74"
					x2="110.91"
					y2="833.38"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="110.91"
					y1="833.38"
					x2="111.29"
					y2="843.05"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="111.29"
					y1="843.05"
					x2="111.29"
					y2="846.21"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="107.66"
					y1="872.51"
					x2="108.51"
					y2="871.91"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="108.51"
					y1="871.91"
					x2="109.79"
					y2="870.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="109.79"
					y1="870.18"
					x2="110.09"
					y2="868.68"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="110.09"
					y1="868.68"
					x2="110.91"
					y2="859.04"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="110.91"
					y1="859.04"
					x2="111.29"
					y2="849.38"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="111.29"
					y1="849.38"
					x2="111.29"
					y2="846.21"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="91.67"
					y1="870.68"
					x2="90.96"
					y2="869.82"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="90.96"
					y1="869.82"
					x2="89.48"
					y2="867.14"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="89.48"
					y1="867.14"
					x2="88.66"
					y2="864.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="88.66"
					y1="864.58"
					x2="88.23"
					y2="861.9"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="89.44"
					y1="816"
					x2="88.23"
					y2="816"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="88.23 882.47 88.23 876.42 89.44 876.42 89.44 882.47 88.23 882.47"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="88.23"
					y1="882.47"
					x2="88.23"
					y2="876.42"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="88.23"
					y1="876.42"
					x2="89.44"
					y2="876.42"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="89.44"
					y1="876.42"
					x2="89.44"
					y2="882.47"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="89.44"
					y1="882.47"
					x2="88.23"
					y2="882.47"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="89.44 812.37 99.27 812.37 99.27 813.58 89.44 813.58 89.44 812.37"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="89.44"
					y1="812.37"
					x2="99.27"
					y2="812.37"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="99.27"
					y1="812.37"
					x2="99.27"
					y2="813.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="99.27"
					y1="813.58"
					x2="89.44"
					y2="813.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="89.44"
					y1="813.58"
					x2="89.44"
					y2="812.37"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="89.44 880.05 89.44 878.84 99.27 878.84 99.27 880.05 89.44 880.05"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="89.44"
					y1="880.05"
					x2="89.44"
					y2="878.84"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="89.44"
					y1="878.84"
					x2="99.27"
					y2="878.84"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="99.27"
					y1="878.84"
					x2="99.27"
					y2="880.05"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="99.27"
					y1="880.05"
					x2="89.44"
					y2="880.05"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="96.25 813.58 98.67 813.58 98.67 878.84 96.25 878.84 96.25 813.58"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="96.25"
					y1="813.58"
					x2="98.67"
					y2="813.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="98.67"
					y1="813.58"
					x2="98.67"
					y2="878.84"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="98.67"
					y1="878.84"
					x2="96.25"
					y2="878.84"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="96.25"
					y1="878.84"
					x2="96.25"
					y2="813.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="581.28 789 683.31 789 683.31 904.66 581.28 904.66 581.28 789"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="581.28"
					y1="789"
					x2="683.31"
					y2="789"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="683.31"
					y1="789"
					x2="683.31"
					y2="904.66"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="683.31"
					y1="904.66"
					x2="581.28"
					y2="904.66"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="581.28"
					y1="904.66"
					x2="581.28"
					y2="789"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="581.28"
					y1="796.55"
					x2="683.31"
					y2="796.55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="841 679.94 909.95 679.94 909.95 612.19 841 612.19 841 679.94"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="841"
					y1="612.19"
					x2="841"
					y2="614.88"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="841"
					y1="619.23"
					x2="841"
					y2="626.48"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="841"
					y1="630.83"
					x2="841"
					y2="638.09"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="841"
					y1="642.44"
					x2="841"
					y2="649.69"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="841"
					y1="654.04"
					x2="841"
					y2="661.29"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="841"
					y1="665.64"
					x2="841"
					y2="672.89"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="841"
					y1="677.24"
					x2="841"
					y2="679.94"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="909.95"
					y1="612.19"
					x2="906.65"
					y2="612.19"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="902.3"
					y1="612.19"
					x2="895.05"
					y2="612.19"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="890.7"
					y1="612.19"
					x2="883.45"
					y2="612.19"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="879.1"
					y1="612.19"
					x2="871.85"
					y2="612.19"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="867.5"
					y1="612.19"
					x2="860.25"
					y2="612.19"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="855.9"
					y1="612.19"
					x2="848.65"
					y2="612.19"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="844.3"
					y1="612.19"
					x2="841"
					y2="612.19"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="909.95"
					y1="679.94"
					x2="909.95"
					y2="677.24"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="909.95"
					y1="672.89"
					x2="909.95"
					y2="665.64"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="909.95"
					y1="661.29"
					x2="909.95"
					y2="654.04"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="909.95"
					y1="649.69"
					x2="909.95"
					y2="642.44"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="909.95"
					y1="638.09"
					x2="909.95"
					y2="630.83"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="909.95"
					y1="626.48"
					x2="909.95"
					y2="619.23"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="909.95"
					y1="614.88"
					x2="909.95"
					y2="612.19"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="841"
					y1="679.94"
					x2="844.3"
					y2="679.94"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="848.65"
					y1="679.94"
					x2="855.9"
					y2="679.94"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="860.25"
					y1="679.94"
					x2="867.5"
					y2="679.94"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="871.85"
					y1="679.94"
					x2="879.1"
					y2="679.94"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="883.45"
					y1="679.94"
					x2="890.7"
					y2="679.94"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="895.05"
					y1="679.94"
					x2="902.3"
					y2="679.94"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="906.65"
					y1="679.94"
					x2="909.95"
					y2="679.94"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="837.43 612.44 835.35 612.44 835.35 679.68 837.43 679.68 837.43 669.14 835.73 669.14 835.73 622.99 837.43 622.99 837.43 612.44"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="837.43"
					y1="622.99"
					x2="837.43"
					y2="612.44"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".28"
				/>
				<line
					x1="835.73"
					y1="622.99"
					x2="837.43"
					y2="622.99"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".28"
				/>
				<line
					x1="835.73"
					y1="669.14"
					x2="835.73"
					y2="622.99"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".28"
				/>
				<line
					x1="837.43"
					y1="669.14"
					x2="835.73"
					y2="669.14"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".28"
				/>
				<line
					x1="837.43"
					y1="679.68"
					x2="837.43"
					y2="669.14"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".28"
				/>
				<line
					x1="835.35"
					y1="679.68"
					x2="837.43"
					y2="679.68"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".28"
				/>
				<line
					x1="835.35"
					y1="612.44"
					x2="835.35"
					y2="679.68"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".28"
				/>
				<line
					x1="837.43"
					y1="612.44"
					x2="835.35"
					y2="612.44"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".28"
				/>
				<polyline
					points="837.43 609.81 837.43 682.32 841 682.32 841 609.81 837.43 609.81"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="841"
					y1="609.81"
					x2="837.43"
					y2="609.81"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".28"
				/>
				<line
					x1="841"
					y1="682.32"
					x2="841"
					y2="609.81"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".28"
				/>
				<line
					x1="837.43"
					y1="682.32"
					x2="841"
					y2="682.32"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".28"
				/>
				<line
					x1="837.43"
					y1="609.81"
					x2="837.43"
					y2="682.32"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".28"
				/>
				<line
					x1="837.43"
					y1="679.68"
					x2="835.35"
					y2="679.68"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="835.35"
					y1="679.68"
					x2="835.35"
					y2="612.44"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="835.35"
					y1="612.44"
					x2="837.43"
					y2="612.44"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="837.43"
					y1="682.32"
					x2="837.43"
					y2="609.81"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="837.43"
					y1="622.99"
					x2="835.73"
					y2="622.99"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="835.73"
					y1="622.99"
					x2="835.73"
					y2="669.14"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="835.73"
					y1="669.14"
					x2="837.43"
					y2="669.14"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="841"
					y1="682.32"
					x2="837.43"
					y2="682.32"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="837.43"
					y1="609.81"
					x2="841"
					y2="609.81"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="841"
					y1="609.81"
					x2="841"
					y2="682.32"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="807.47 797.74 716.84 797.74 716.84 876.29 807.47 876.29 807.47 797.74"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="807.47"
					y1="797.74"
					x2="716.84"
					y2="797.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="807.47"
					y1="876.29"
					x2="716.84"
					y2="876.29"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="807.47"
					y1="873.91"
					x2="716.84"
					y2="873.91"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="807.47"
					y1="797.74"
					x2="807.47"
					y2="876.29"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="716.84"
					y1="797.74"
					x2="716.84"
					y2="876.29"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="801.53"
					y1="801.31"
					x2="722.78"
					y2="801.31"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="722.78"
					y1="801.31"
					x2="720.41"
					y2="803.68"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="720.41"
					y1="803.68"
					x2="720.41"
					y2="870.34"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="720.41"
					y1="870.34"
					x2="722.78"
					y2="872.72"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="722.78"
					y1="872.72"
					x2="801.53"
					y2="872.72"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="801.53"
					y1="872.72"
					x2="803.91"
					y2="870.34"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="803.91"
					y1="870.34"
					x2="803.91"
					y2="803.68"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="803.91"
					y1="803.68"
					x2="801.53"
					y2="801.31"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m796.71,817.37c0-6.57-5.33-11.9-11.89-11.9s-11.9,5.33-11.9,11.9,5.32,11.9,11.9,11.9,11.89-5.32,11.89-11.9"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m793.74,856.65c0-4.92-3.99-8.92-8.92-8.92s-8.92,3.99-8.92,8.92,3.99,8.92,8.92,8.92,8.92-3.99,8.92-8.92"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m748.42,817.37c0-4.92-3.99-8.92-8.92-8.92s-8.92,3.99-8.92,8.92,3.99,8.92,8.92,8.92,8.92-3.99,8.92-8.92"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m751.39,856.65c0-6.57-5.32-11.9-11.9-11.9s-11.89,5.33-11.89,11.9,5.33,11.9,11.89,11.9,11.9-5.32,11.9-11.9"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="849.69 692.2 849.69 767.45 850.01 768.64 850.88 769.51 852.07 769.83 902.45 769.83 903.64 769.51 904.51 768.64 904.83 767.45 904.83 692.2 904.51 691.01 903.64 690.14 902.45 689.82 852.07 689.82 850.88 690.14 850.01 691.01 849.69 692.2"
					fill="none"
					fillRule="evenodd"
				/>
				<path
					d="m849.69,692.2c0-1.31,1.07-2.38,2.38-2.38"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="902.45"
					y1="689.82"
					x2="852.07"
					y2="689.82"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m902.45,689.82c1.31,0,2.38,1.07,2.38,2.38"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="904.83"
					y1="767.45"
					x2="904.83"
					y2="692.2"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m904.83,767.45c0,1.31-1.07,2.38-2.38,2.38"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="852.07"
					y1="769.83"
					x2="902.45"
					y2="769.83"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m852.07,769.83c-1.31,0-2.38-1.07-2.38-2.38"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="849.69"
					y1="692.2"
					x2="849.69"
					y2="767.45"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="855.64"
					y1="698.15"
					x2="855.64"
					y2="761.51"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="858.02"
					y1="763.88"
					x2="890.55"
					y2="763.88"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="892.93"
					y1="761.51"
					x2="892.93"
					y2="698.15"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="890.55"
					y1="695.77"
					x2="858.02"
					y2="695.77"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="855.64"
					y1="698.15"
					x2="855.64"
					y2="698.15"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m858.02,763.88c-1.31,0-2.38-1.07-2.38-2.38"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m892.93,761.51c0,1.31-1.07,2.38-2.38,2.38"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m890.55,695.77c1.31,0,2.38,1.07,2.38,2.38"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m855.64,698.15c0-1.31,1.07-2.38,2.38-2.38"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m884.61,729.83c0-1.97-1.6-3.57-3.57-3.57s-3.57,1.6-3.57,3.57,1.6,3.57,3.57,3.57,3.57-1.6,3.57-3.57"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="877.72 728.76 876.97 729.07 876.66 729.83 876.97 730.59 877.73 730.9 901.26 730.9 902.02 730.59 902.33 729.83 902.02 729.07 901.26 728.76 877.72 728.76"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="901.26"
					y1="728.76"
					x2="877.72"
					y2="728.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m901.26,728.76c.59,0,1.07.48,1.07,1.07s-.48,1.07-1.07,1.07"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="877.73"
					y1="730.9"
					x2="901.26"
					y2="730.9"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m877.73,730.9h0c-.59,0-1.07-.48-1.07-1.07s.48-1.07,1.07-1.07"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="895.2 727.45 895.2 728.76 901.26 728.76 902.02 729.07 902.33 729.83 902.02 730.59 901.26 730.9 895.2 730.9 895.2 732.2 902.93 732.2 902.93 727.45 895.2 727.45"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="902.93"
					y1="727.45"
					x2="895.2"
					y2="727.45"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="902.93"
					y1="732.2"
					x2="902.93"
					y2="727.45"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="895.2"
					y1="732.2"
					x2="902.93"
					y2="732.2"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="895.2"
					y1="730.9"
					x2="895.2"
					y2="732.2"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="901.26"
					y1="730.9"
					x2="895.2"
					y2="730.9"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m901.26,728.76c.59,0,1.07.48,1.07,1.07s-.48,1.07-1.07,1.07"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="895.2"
					y1="728.76"
					x2="901.26"
					y2="728.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="895.2"
					y1="727.45"
					x2="895.2"
					y2="728.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="890.91 727.49 890.91 728.76 895.08 728.76 895.08 727.49 890.91 727.49"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="895.08"
					y1="727.49"
					x2="890.91"
					y2="727.49"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="895.08"
					y1="728.76"
					x2="895.08"
					y2="727.49"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="890.91"
					y1="728.76"
					x2="895.08"
					y2="728.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="890.91"
					y1="727.49"
					x2="890.91"
					y2="728.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="890.91 732.17 895.08 732.17 895.08 730.9 890.91 730.9 890.91 732.17"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="890.91"
					y1="730.9"
					x2="890.91"
					y2="732.17"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="895.08"
					y1="730.9"
					x2="890.91"
					y2="730.9"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="895.08"
					y1="732.17"
					x2="895.08"
					y2="730.9"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="890.91"
					y1="732.17"
					x2="895.08"
					y2="732.17"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="111.85"
					y1="717.88"
					x2="288.61"
					y2="717.88"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="111.85"
					y1="627.9"
					x2="111.85"
					y2="717.88"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="122.92 638.56 122.92 706.04 276.77 706.04 276.77 638.56 122.92 638.56"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="276.77"
					y1="638.56"
					x2="122.92"
					y2="638.56"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="276.77"
					y1="706.04"
					x2="276.77"
					y2="638.56"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="122.92"
					y1="706.04"
					x2="276.77"
					y2="706.04"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="122.92"
					y1="638.56"
					x2="122.92"
					y2="706.04"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="138.04 672.89 137.99 672.29 137.83 671.7 137.59 671.15 137.25 670.65 136.83 670.22 136.35 669.87 135.82 669.61 135.25 669.45 134.66 669.4 134.08 669.45 133.51 669.61 132.98 669.87 132.49 670.22 132.08 670.65 131.74 671.15 131.49 671.7 131.34 672.29 131.29 672.89 131.34 673.5 131.49 674.08 131.74 674.63 132.08 675.13 132.49 675.56 132.98 675.91 133.51 676.17 134.08 676.33 134.66 676.38 135.25 676.33 135.82 676.17 136.35 675.91 136.83 675.56 137.25 675.13 137.59 674.63 137.83 674.08 137.99 673.5 138.04 672.89"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="137.99"
					y1="673.5"
					x2="138.04"
					y2="672.89"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="137.83"
					y1="674.08"
					x2="137.99"
					y2="673.5"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="137.59"
					y1="674.63"
					x2="137.83"
					y2="674.08"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="137.25"
					y1="675.13"
					x2="137.59"
					y2="674.63"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="136.83"
					y1="675.56"
					x2="137.25"
					y2="675.13"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="136.35"
					y1="675.91"
					x2="136.83"
					y2="675.56"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="135.82"
					y1="676.17"
					x2="136.35"
					y2="675.91"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="135.25"
					y1="676.33"
					x2="135.82"
					y2="676.17"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="134.66"
					y1="676.38"
					x2="135.25"
					y2="676.33"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="134.08"
					y1="676.33"
					x2="134.66"
					y2="676.38"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="133.51"
					y1="676.17"
					x2="134.08"
					y2="676.33"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="132.98"
					y1="675.91"
					x2="133.51"
					y2="676.17"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="132.49"
					y1="675.56"
					x2="132.98"
					y2="675.91"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="132.08"
					y1="675.13"
					x2="132.49"
					y2="675.56"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="131.74"
					y1="674.63"
					x2="132.08"
					y2="675.13"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="131.49"
					y1="674.08"
					x2="131.74"
					y2="674.63"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="131.34"
					y1="673.5"
					x2="131.49"
					y2="674.08"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="131.29"
					y1="672.89"
					x2="131.34"
					y2="673.5"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="131.34"
					y1="672.29"
					x2="131.29"
					y2="672.89"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="131.49"
					y1="671.7"
					x2="131.34"
					y2="672.29"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="131.74"
					y1="671.15"
					x2="131.49"
					y2="671.7"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="132.08"
					y1="670.65"
					x2="131.74"
					y2="671.15"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="132.49"
					y1="670.22"
					x2="132.08"
					y2="670.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="132.98"
					y1="669.87"
					x2="132.49"
					y2="670.22"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="133.51"
					y1="669.61"
					x2="132.98"
					y2="669.87"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="134.08"
					y1="669.45"
					x2="133.51"
					y2="669.61"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="134.66"
					y1="669.4"
					x2="134.08"
					y2="669.45"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="135.25"
					y1="669.45"
					x2="134.66"
					y2="669.4"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="135.82"
					y1="669.61"
					x2="135.25"
					y2="669.45"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="136.35"
					y1="669.87"
					x2="135.82"
					y2="669.61"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="136.83"
					y1="670.22"
					x2="136.35"
					y2="669.87"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="137.25"
					y1="670.65"
					x2="136.83"
					y2="670.22"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="137.59"
					y1="671.15"
					x2="137.25"
					y2="670.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="137.83"
					y1="671.7"
					x2="137.59"
					y2="671.15"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="137.99"
					y1="672.29"
					x2="137.83"
					y2="671.7"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="138.04"
					y1="672.89"
					x2="137.99"
					y2="672.29"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="118.97 675.9 118.46 675.85 117.97 675.72 117.51 675.5 117.1 675.19 116.74 674.83 116.45 674.4 116.23 673.92 116.1 673.41 116.06 672.89 116.1 672.37 116.23 671.86 116.45 671.39 116.74 670.96 117.1 670.58 117.51 670.28 117.97 670.06 118.46 669.93 118.97 669.88 123.86 670.36 124.24 670.43 124.62 670.56 124.96 670.75 131.13 671.55 131.35 671.6 131.55 671.68 131.74 671.8 131.91 671.96 132.05 672.13 132.16 672.34 132.23 672.55 132.27 672.78 132.27 673.01 132.23 673.23 132.16 673.45 132.05 673.65 131.91 673.82 131.74 673.97 131.55 674.09 131.35 674.18 131.13 674.23 124.96 675.02 124.62 675.22 124.24 675.35 123.86 675.42 118.97 675.9"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="118.97"
					y1="675.9"
					x2="123.86"
					y2="675.42"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="124.96"
					y1="675.02"
					x2="131.13"
					y2="674.23"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="131.13"
					y1="671.55"
					x2="124.96"
					y2="670.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="123.86"
					y1="670.36"
					x2="118.97"
					y2="669.88"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="121.87"
					y1="671.25"
					x2="123.6"
					y2="671.25"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="123.6"
					y1="674.53"
					x2="121.87"
					y2="674.53"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="121.87"
					y1="674.53"
					x2="121.87"
					y2="671.25"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m124.96,675.02c-.33.22-.71.36-1.11.4"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m131.13,671.55c.65.09,1.14.66,1.14,1.34s-.49,1.25-1.14,1.34"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m123.86,670.36c.39.03.77.17,1.11.39"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m118.97,675.9c-1.61,0-2.91-1.35-2.91-3.01s1.3-3.01,2.91-3.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m123.6,671.25c.87,0,1.58.73,1.58,1.64s-.71,1.64-1.58,1.64"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m124.96,670.75c.7.47,1.13,1.27,1.13,2.13s-.42,1.67-1.13,2.13"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="456.06"
					y1="568.67"
					x2="477.21"
					y2="568.67"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="477.21"
					y1="568.67"
					x2="477.21"
					y2="511.26"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="456.06"
					y1="580.76"
					x2="456.06"
					y2="499.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="401.68"
					y1="499.18"
					x2="401.68"
					y2="580.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="401.68"
					y1="580.76"
					x2="483.26"
					y2="580.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="483.26"
					y1="499.18"
					x2="401.68"
					y2="499.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="481.75"
					y1="580.76"
					x2="481.75"
					y2="499.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="456.06"
					y1="511.26"
					x2="477.21"
					y2="511.26"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="483.26"
					y1="580.76"
					x2="483.26"
					y2="499.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="680.29"
					y1="789"
					x2="680.29"
					y2="783.03"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="680.29"
					y1="783.03"
					x2="677.27"
					y2="783.03"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="677.27"
					y1="783.03"
					x2="677.27"
					y2="789"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="581.28"
					y1="803.78"
					x2="583.72"
					y2="803.78"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="588.06"
					y1="803.78"
					x2="595.32"
					y2="803.78"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="599.67"
					y1="803.78"
					x2="606.92"
					y2="803.78"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="611.27"
					y1="803.78"
					x2="618.52"
					y2="803.78"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="622.87"
					y1="803.78"
					x2="630.12"
					y2="803.78"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="634.47"
					y1="803.78"
					x2="641.72"
					y2="803.78"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="646.07"
					y1="803.78"
					x2="653.33"
					y2="803.78"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="657.68"
					y1="803.78"
					x2="664.93"
					y2="803.78"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="669.28"
					y1="803.78"
					x2="676.53"
					y2="803.78"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="680.88"
					y1="803.78"
					x2="683.31"
					y2="803.78"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="683.31"
					y1="876.29"
					x2="683.31"
					y2="803.78"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="841"
					y1="607.41"
					x2="913.51"
					y2="607.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="393.67"
					y1="69.66"
					x2="191.38"
					y2="69.66"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="191.38"
					y1="93.83"
					x2="393.67"
					y2="93.83"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="610.99"
					y1="93.83"
					x2="846.62"
					y2="93.83"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="846.62"
					y1="69.66"
					x2="610.99"
					y2="69.66"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="410.74"
					y1="568.67"
					x2="410.74"
					y2="511.26"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="410.74"
					y1="511.26"
					x2="450.02"
					y2="511.26"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="450.02"
					y1="511.26"
					x2="450.02"
					y2="568.67"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="450.02"
					y1="568.67"
					x2="410.74"
					y2="568.67"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="683.31"
					y1="840.03"
					x2="685.56"
					y2="840.03"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="689.64"
					y1="840.03"
					x2="696.9"
					y2="840.03"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="701.25"
					y1="840.03"
					x2="708.5"
					y2="840.03"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="712.85"
					y1="840.03"
					x2="720.1"
					y2="840.03"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="724.45"
					y1="840.03"
					x2="731.7"
					y2="840.03"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="736.05"
					y1="840.03"
					x2="743.3"
					y2="840.03"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="747.66"
					y1="840.03"
					x2="754.9"
					y2="840.03"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="759.26"
					y1="840.03"
					x2="766.51"
					y2="840.03"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="770.86"
					y1="840.03"
					x2="778.11"
					y2="840.03"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="782.46"
					y1="840.03"
					x2="789.71"
					y2="840.03"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="794.06"
					y1="840.03"
					x2="801.31"
					y2="840.03"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="805.66"
					y1="840.03"
					x2="812.91"
					y2="840.03"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="817.27"
					y1="840.03"
					x2="824.52"
					y2="840.03"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="828.87"
					y1="840.03"
					x2="836.12"
					y2="840.03"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="840.47"
					y1="840.03"
					x2="847.72"
					y2="840.03"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="852.07"
					y1="840.03"
					x2="859.32"
					y2="840.03"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="863.67"
					y1="840.03"
					x2="870.93"
					y2="840.03"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="875.01"
					y1="840.03"
					x2="877.26"
					y2="840.03"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="877.26"
					y1="840.03"
					x2="877.26"
					y2="836.11"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="877.26"
					y1="831.76"
					x2="877.26"
					y2="824.51"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="877.26"
					y1="820.16"
					x2="877.26"
					y2="812.91"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="877.26"
					y1="808.56"
					x2="877.26"
					y2="801.31"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="877.26"
					y1="796.96"
					x2="877.26"
					y2="789.7"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="877.26"
					y1="785.36"
					x2="877.26"
					y2="778.1"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="877.26"
					y1="773.75"
					x2="877.26"
					y2="766.5"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="877.26"
					y1="762.15"
					x2="877.26"
					y2="754.9"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="877.26"
					y1="750.55"
					x2="877.26"
					y2="743.3"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="877.26"
					y1="738.95"
					x2="877.26"
					y2="731.7"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="877.26"
					y1="727.35"
					x2="877.26"
					y2="720.09"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="877.26"
					y1="715.75"
					x2="877.26"
					y2="708.49"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="877.26"
					y1="704.14"
					x2="877.26"
					y2="696.89"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="877.26"
					y1="692.54"
					x2="877.26"
					y2="685.29"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="877.26"
					y1="680.94"
					x2="877.26"
					y2="673.69"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="877.26"
					y1="669.34"
					x2="877.26"
					y2="662.09"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="877.26"
					y1="657.74"
					x2="877.26"
					y2="650.48"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="877.26"
					y1="646.14"
					x2="877.26"
					y2="638.88"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="877.26"
					y1="634.53"
					x2="877.26"
					y2="627.28"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="877.26"
					y1="622.93"
					x2="877.26"
					y2="615.68"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="877.26"
					y1="611.33"
					x2="877.26"
					y2="607.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
			</g>
			<g id="walls">
				<polygon
					points="610.99 69.66 610.99 93.83 502.86 93.83 502.86 362.39 487.76 362.39 487.76 192.62 420.46 192.62 420.46 93.83 393.67 93.83 393.67 69.66 610.99 69.66"
					fill="none"
					fillRule="evenodd"
					stroke="#000"
					strokeMiterlimit="10"
					strokeWidth="1.26"
				/>
				<polygon
					points="950 69.66 950 530.39 937.68 530.39 937.68 928.83 421.76 928.83 421.76 904.66 683.3 904.66 683.3 876.3 913.51 876.3 913.51 506.22 925.83 506.22 925.83 93.83 846.62 93.83 846.62 69.66 950 69.66"
					fill="none"
					fillRule="evenodd"
					stroke="#000"
					strokeMiterlimit="10"
					strokeWidth="1.26"
				/>
				<polygon
					points="487.76 496.16 487.76 492.66 393.46 492.66 393.46 587.28 487.76 587.28 487.76 583.78 502.86 583.78 502.86 715.86 442.01 715.86 442.01 700.76 487.76 700.76 487.76 627.9 303.71 627.9 303.71 700.76 345.34 700.76 345.34 715.86 303.71 715.86 303.71 797.96 288.61 797.96 288.61 627.9 111.85 627.9 111.85 717.88 88.23 717.88 88.23 904.66 288.61 904.66 288.61 894.65 303.71 894.65 303.71 904.66 306.95 904.66 306.95 928.83 64.06 928.83 64.06 717.88 50 717.88 50 69.66 191.38 69.66 191.38 93.83 87.71 93.83 87.71 144.07 74.17 144.07 74.17 531.07 114.52 531.07 114.52 546.17 74.17 546.17 74.17 612.8 378.35 612.8 378.35 546.17 329.91 546.17 329.91 531.07 378.35 531.07 378.35 477.56 487.76 477.56 487.76 459.08 502.86 459.08 502.86 496.16 487.76 496.16"
					fill="none"
					fillRule="evenodd"
					stroke="#000"
					strokeMiterlimit="10"
					strokeWidth="1.26"
				/>
			</g>
			<g id="text">
				<path d="m627.87,855.23h-1.97l-2.36-3.95c-.22-.37-.43-.68-.63-.93-.2-.26-.41-.48-.63-.64-.21-.16-.44-.28-.69-.35-.24-.08-.52-.12-.83-.12h-1.36v6h-1.65v-14.11h4.21c.62,0,1.18.08,1.7.24.52.15.98.38,1.36.7.39.31.69.71.91,1.18.22.47.32,1.01.32,1.64,0,.49-.08.94-.23,1.36-.14.41-.35.77-.63,1.09-.27.32-.6.6-.98.83-.38.22-.81.4-1.29.52v.04c.24.1.44.23.61.36.18.13.34.29.5.47.16.18.31.39.46.63.16.23.33.5.52.81l2.65,4.24Zm-8.46-12.61v5.12h2.24c.41,0,.79-.06,1.14-.19.35-.12.66-.3.91-.53.26-.24.46-.52.6-.86.14-.34.22-.72.22-1.14,0-.75-.25-1.34-.74-1.76-.49-.43-1.19-.64-2.12-.64h-2.26Zm18.09,7.98h-7.11c.03,1.12.33,1.99.91,2.6.58.61,1.37.91,2.38.91,1.13,0,2.18-.37,3.13-1.12v1.52c-.89.64-2.06.96-3.51.96s-2.54-.46-3.35-1.37c-.81-.92-1.22-2.21-1.22-3.87,0-1.57.44-2.84,1.33-3.83.89-.99,2-1.49,3.32-1.49s2.34.43,3.06,1.28c.72.85,1.08,2.04,1.08,3.55v.85Zm-1.65-1.37c0-.93-.23-1.66-.68-2.17-.44-.52-1.05-.78-1.84-.78s-1.41.27-1.94.82c-.53.54-.86,1.26-.98,2.13h5.44Zm8.89-7.5c-.31-.18-.67-.27-1.07-.27-1.13,0-1.69.71-1.69,2.13v1.55h2.36v1.38h-2.36v8.7h-1.6v-8.7h-1.72v-1.38h1.72v-1.63c0-1.06.3-1.89.91-2.5.61-.62,1.37-.92,2.28-.92.49,0,.88.06,1.17.18v1.46Z" />
				<path d="m646.45,855.44c-.3,0-.56-.11-.78-.32-.21-.22-.31-.48-.31-.78s.1-.56.31-.78c.22-.22.48-.33.78-.33s.57.11.79.33c.22.22.32.48.32.78s-.11.56-.32.78c-.22.22-.48.32-.79.32Z" />
				<path d="m878.75,652.38v-14.02h4.83c1.09,0,1.92.07,2.5.2.8.18,1.49.52,2.06,1,.74.62,1.29,1.42,1.65,2.4.37.97.55,2.08.55,3.33,0,1.06-.12,2.01-.37,2.83-.25.82-.57,1.5-.96,2.05-.39.54-.82.96-1.28,1.27-.46.31-1.02.54-1.67.7-.65.16-1.4.24-2.25.24h-5.06Zm1.86-1.65h2.99c.92,0,1.65-.09,2.17-.26.53-.17.95-.41,1.26-.73.44-.44.78-1.03,1.02-1.77.25-.75.37-1.65.37-2.71,0-1.47-.24-2.59-.73-3.38-.48-.79-1.06-1.32-1.75-1.59-.5-.19-1.3-.29-2.4-.29h-2.95v10.71Zm14.73,1.65l-3.72-14.02h1.9l2.13,9.19c.23.96.43,1.92.59,2.87.36-1.5.57-2.36.63-2.59l2.67-9.47h2.24l2.01,7.1c.5,1.76.87,3.41,1.09,4.96.18-.89.41-1.9.7-3.05l2.2-9.01h1.86l-3.84,14.02h-1.79l-2.95-10.68c-.25-.89-.4-1.44-.44-1.64-.15.64-.28,1.19-.41,1.64l-2.97,10.68h-1.89Z" />
				<path d="m591.68,402.72h-11.37v-21.91h2.57v19.58h8.8v2.32Zm4.3-19.61c-.45,0-.83-.15-1.15-.46-.32-.31-.47-.69-.47-1.16s.16-.86.47-1.16c.32-.32.7-.47,1.15-.47s.85.16,1.16.47c.33.31.49.69.49,1.16s-.16.83-.49,1.15c-.32.32-.7.47-1.16.47Zm1.22,19.61h-2.51v-15.64h2.51v15.64Zm17.35-15.64l-6.23,15.64h-2.46l-5.93-15.64h2.75l3.97,11.37c.3.84.48,1.56.55,2.18h.06c.1-.78.26-1.49.49-2.12l4.15-11.43h2.64Zm3.96-3.97c-.45,0-.83-.15-1.15-.46-.32-.31-.47-.69-.47-1.16s.16-.86.47-1.16c.32-.32.7-.47,1.15-.47s.85.16,1.16.47c.33.31.49.69.49,1.16s-.16.83-.49,1.15c-.32.32-.7.47-1.16.47Zm1.22,19.61h-2.51v-15.64h2.51v15.64Zm18.04,0h-2.51v-8.92c0-3.32-1.21-4.98-3.64-4.98-1.25,0-2.29.47-3.12,1.42-.81.94-1.22,2.12-1.22,3.56v8.92h-2.51v-15.64h2.51v2.6h.06c1.18-1.98,2.89-2.96,5.13-2.96,1.71,0,3.02.56,3.93,1.67.91,1.1,1.36,2.69,1.36,4.78v9.56Zm18.06-1.25c0,5.74-2.75,8.62-8.25,8.62-1.93,0-3.63-.37-5.07-1.1v-2.51c1.76.98,3.44,1.47,5.04,1.47,3.85,0,5.77-2.05,5.77-6.14v-1.71h-.06c-1.19,2-2.98,2.99-5.38,2.99-1.95,0-3.51-.69-4.71-2.08-1.18-1.4-1.77-3.26-1.77-5.61,0-2.66.64-4.77,1.91-6.34,1.28-1.57,3.03-2.35,5.25-2.35s3.67.85,4.69,2.54h.06v-2.17h2.51v14.39Zm-2.51-5.82v-2.31c0-1.24-.42-2.31-1.27-3.19-.84-.89-1.88-1.33-3.13-1.33-1.55,0-2.76.57-3.64,1.7-.88,1.12-1.31,2.69-1.31,4.72,0,1.74.42,3.14,1.25,4.19.85,1.04,1.96,1.56,3.35,1.56s2.55-.5,3.42-1.5c.89-1,1.33-2.28,1.33-3.83Z" />
				<polygon points="670.77 380.81 660.26 406.35 657.93 406.35 668.41 380.81 670.77 380.81" />
				<path d="m673.32,402.72v-21.91h6.05c7.72,0,11.58,3.56,11.58,10.68,0,3.38-1.07,6.1-3.22,8.16-2.14,2.05-5.01,3.07-8.6,3.07h-5.8Zm2.57-19.58v17.26h3.27c2.87,0,5.11-.77,6.71-2.31,1.6-1.54,2.4-3.72,2.4-6.54,0-5.61-2.98-8.42-8.95-8.42h-3.42Zm20.21-.03c-.45,0-.83-.15-1.15-.46-.32-.31-.47-.69-.47-1.16s.16-.86.47-1.16c.32-.32.7-.47,1.15-.47s.85.16,1.16.47c.33.31.49.69.49,1.16s-.16.83-.49,1.15c-.32.32-.7.47-1.16.47Zm1.22,19.61h-2.51v-15.64h2.51v15.64Zm17.95,0h-2.51v-8.92c0-3.32-1.21-4.98-3.64-4.98-1.25,0-2.29.47-3.12,1.42-.81.94-1.22,2.12-1.22,3.56v8.92h-2.51v-15.64h2.51v2.6h.06c1.18-1.98,2.89-2.96,5.13-2.96,1.71,0,3.02.56,3.93,1.67.91,1.1,1.36,2.69,1.36,4.78v9.56Zm5.91-19.61c-.45,0-.83-.15-1.15-.46s-.47-.69-.47-1.16.16-.86.47-1.16c.32-.32.7-.47,1.15-.47s.85.16,1.16.47c.33.31.49.69.49,1.16s-.16.83-.49,1.15c-.32.32-.7.47-1.16.47Zm1.22,19.61h-2.51v-15.64h2.51v15.64Zm17.95,0h-2.51v-8.92c0-3.32-1.21-4.98-3.64-4.98-1.25,0-2.29.47-3.12,1.42-.81.94-1.22,2.12-1.22,3.56v8.92h-2.51v-15.64h2.51v2.6h.06c1.18-1.98,2.89-2.96,5.13-2.96,1.71,0,3.02.56,3.93,1.67.91,1.1,1.36,2.69,1.36,4.78v9.56Zm17.98-1.25c0,5.74-2.75,8.62-8.25,8.62-1.94,0-3.63-.37-5.07-1.1v-2.51c1.76.98,3.44,1.47,5.04,1.47,3.85,0,5.77-2.05,5.77-6.14v-1.71h-.06c-1.19,2-2.98,2.99-5.38,2.99-1.95,0-3.51-.69-4.71-2.08-1.18-1.4-1.77-3.26-1.77-5.61,0-2.66.64-4.77,1.91-6.34,1.28-1.57,3.03-2.35,5.26-2.35s3.67.85,4.69,2.54h.06v-2.17h2.51v14.39Zm-2.51-5.82v-2.31c0-1.24-.42-2.31-1.27-3.19-.84-.89-1.88-1.33-3.13-1.33-1.55,0-2.76.57-3.64,1.7-.88,1.12-1.31,2.69-1.31,4.72,0,1.74.42,3.14,1.25,4.19.85,1.04,1.96,1.56,3.35,1.56s2.55-.5,3.42-1.5c.89-1,1.33-2.28,1.33-3.83Z" />
				<path d="m788.29,402.72h-3.06l-3.67-6.14c-.34-.57-.66-1.05-.98-1.45-.32-.41-.64-.74-.98-.99-.33-.25-.68-.44-1.07-.55-.38-.12-.8-.18-1.28-.18h-2.11v9.32h-2.57v-21.91h6.54c.96,0,1.84.12,2.64.37.81.23,1.52.6,2.11,1.08.6.49,1.07,1.1,1.41,1.83.34.72.5,1.57.5,2.55,0,.76-.12,1.47-.35,2.11-.22.63-.55,1.2-.98,1.7-.42.5-.93.93-1.53,1.28-.59.35-1.26.62-2,.81v.06c.37.16.68.35.95.57.27.2.53.45.78.73.24.29.48.61.72.98.24.36.51.77.81,1.25l4.11,6.58Zm-13.14-19.58v7.94h3.48c.64,0,1.23-.1,1.77-.29.55-.19,1.02-.47,1.42-.82.4-.37.71-.81.93-1.33.22-.53.34-1.12.34-1.77,0-1.17-.38-2.08-1.15-2.73-.75-.66-1.85-.99-3.28-.99h-3.51Zm22.25,19.95c-2.31,0-4.16-.73-5.55-2.18-1.37-1.47-2.06-3.41-2.06-5.82,0-2.63.72-4.68,2.15-6.16,1.44-1.48,3.38-2.21,5.82-2.21s4.15.72,5.45,2.15c1.31,1.44,1.97,3.43,1.97,5.97s-.71,4.5-2.12,6c-1.41,1.5-3.29,2.25-5.67,2.25Zm.18-14.27c-1.61,0-2.88.55-3.82,1.65-.94,1.09-1.41,2.6-1.41,4.52s.47,3.31,1.42,4.38c.95,1.07,2.21,1.6,3.8,1.6s2.86-.52,3.73-1.57c.88-1.05,1.31-2.54,1.31-4.48s-.44-3.46-1.31-4.52c-.87-1.06-2.11-1.59-3.73-1.59Zm18.05,14.27c-2.31,0-4.16-.73-5.55-2.18-1.37-1.47-2.06-3.41-2.06-5.82,0-2.63.72-4.68,2.15-6.16,1.44-1.48,3.38-2.21,5.82-2.21s4.15.72,5.45,2.15c1.31,1.44,1.97,3.43,1.97,5.97s-.71,4.5-2.12,6c-1.41,1.5-3.29,2.25-5.67,2.25Zm.18-14.27c-1.61,0-2.88.55-3.82,1.65-.94,1.09-1.41,2.6-1.41,4.52s.47,3.31,1.42,4.38c.95,1.07,2.21,1.6,3.8,1.6s2.86-.52,3.73-1.57c.88-1.05,1.31-2.54,1.31-4.48s-.44-3.46-1.31-4.52c-.87-1.06-2.11-1.59-3.73-1.59Zm33.72,13.9h-2.51v-8.98c0-1.73-.27-2.98-.81-3.76-.53-.77-1.43-1.16-2.69-1.16-1.07,0-1.98.49-2.73,1.47-.74.98-1.12,2.15-1.12,3.51v8.92h-2.51v-9.29c0-3.08-1.19-4.61-3.56-4.61-1.1,0-2.01.46-2.72,1.39-.71.92-1.07,2.11-1.07,3.59v8.92h-2.51v-15.64h2.51v2.47h.06c1.11-1.89,2.73-2.84,4.86-2.84,1.07,0,2,.3,2.8.9.79.59,1.34,1.37,1.63,2.34,1.16-2.16,2.89-3.24,5.19-3.24,3.44,0,5.16,2.12,5.16,6.37v9.64Z" />
				<path d="m659.98,435.18h-1.82v-13.77c-.14.14-.35.3-.62.49-.27.18-.57.36-.91.53-.33.18-.69.34-1.07.5-.37.16-.73.28-1.09.37v-1.84c.4-.11.82-.26,1.27-.44.45-.19.89-.4,1.32-.63.44-.24.85-.48,1.23-.73.39-.26.72-.51,1-.76h.69v16.29Zm12.28,0h-1.82v-13.77c-.14.14-.35.3-.62.49-.27.18-.57.36-.91.53-.33.18-.69.34-1.07.5-.37.16-.73.28-1.09.37v-1.84c.4-.11.82-.26,1.27-.44.45-.19.89-.4,1.32-.63.44-.24.85-.48,1.23-.73.39-.26.72-.51,1-.76h.69v16.29Z" />
				<rect x="678.32" y="419.25" width="1.61" height="4.97" />
				<path d="m692.82,426.26c0,1.46-.14,2.76-.43,3.9-.29,1.13-.71,2.1-1.27,2.89-.56.79-1.23,1.39-2.03,1.8-.8.41-1.71.61-2.73.61s-1.98-.19-2.78-.56v-1.74c.88.5,1.82.74,2.82.74.72,0,1.36-.15,1.92-.44.57-.3,1.05-.73,1.44-1.29.39-.57.69-1.27.9-2.1.21-.83.31-1.78.31-2.86h-.04c-.68,1.37-1.87,2.06-3.56,2.06-.68,0-1.31-.12-1.88-.36-.57-.24-1.06-.59-1.48-1.02-.41-.44-.74-.97-.97-1.58-.23-.61-.34-1.28-.34-2.01,0-.79.13-1.5.38-2.16.26-.65.61-1.21,1.07-1.68.46-.47,1-.84,1.62-1.1.63-.26,1.31-.39,2.06-.39.8,0,1.51.16,2.12.49.62.32,1.14.79,1.57,1.41.42.61.74,1.37.97,2.28.22.9.33,1.94.33,3.1Zm-1.97-1.63c0-.61-.08-1.17-.24-1.68-.16-.5-.37-.93-.66-1.29-.28-.36-.62-.64-1.01-.83-.39-.2-.81-.3-1.27-.3s-.84.09-1.22.27c-.38.17-.71.41-.99.73-.27.31-.49.69-.66,1.12-.16.43-.23.9-.23,1.41,0,.56.07,1.07.22,1.51.16.44.37.82.66,1.13.28.3.62.54,1.01.7.4.16.84.24,1.32.24.42,0,.82-.08,1.19-.23.38-.16.7-.38.98-.64.28-.27.5-.59.66-.96.16-.37.24-.77.24-1.19Z" />
				<path d="m697.37,419.25v4.97h-1.61v-4.97h1.61Zm3.69,0v4.97h-1.61v-4.97h1.61Z" />
				<path d="m719.27,423.8l-3.82,5.76,3.76,5.62h-2.12l-2.23-3.69c-.14-.23-.31-.52-.5-.87h-.04c-.04.07-.21.36-.52.87l-2.28,3.69h-2.1l3.88-5.58-3.71-5.8h2.12l2.2,3.89c.16.29.32.59.48.89h.04l2.84-4.78h2.01Z" />
				<path d="m733.84,435.18h-1.82v-13.77c-.14.14-.35.3-.62.49-.27.18-.57.36-.91.53-.33.18-.69.34-1.07.5-.37.16-.73.28-1.09.37v-1.84c.4-.11.82-.26,1.27-.44.45-.19.89-.4,1.32-.63.44-.24.85-.48,1.23-.73.39-.26.72-.51,1-.76h.69v16.29Zm15.46-14.88c-.24.42-.54.95-.89,1.58-.34.63-.7,1.34-1.09,2.12-.39.79-.78,1.63-1.18,2.53-.4.9-.77,1.84-1.12,2.8s-.66,1.94-.92,2.93c-.26.99-.45,1.96-.57,2.91h-1.96c.13-.95.34-1.91.61-2.9.28-.99.6-1.96.94-2.91.36-.96.73-1.87,1.12-2.76.39-.88.77-1.69,1.14-2.43.37-.74.71-1.39,1.01-1.96.31-.57.56-1.01.74-1.33h-7.99v-1.64h10.13v1.06Z" />
				<rect x="752.17" y="419.25" width="1.61" height="4.97" />
				<path d="m763.56,435.18h-1.82v-13.77c-.14.14-.35.3-.62.49-.27.18-.57.36-.91.53-.33.18-.69.34-1.07.5-.37.16-.73.28-1.09.37v-1.84c.4-.11.82-.26,1.27-.44.45-.19.89-.4,1.32-.63.44-.24.85-.48,1.23-.73.39-.26.72-.51,1-.76h.69v16.29Z" />
				<path d="m771.23,419.25v4.97h-1.61v-4.97h1.61Zm3.69,0v4.97h-1.61v-4.97h1.61Z" />
				<path d="m216.47,310.32v-21.91h6.23c1.89,0,3.4.46,4.51,1.39,1.11.93,1.67,2.13,1.67,3.62,0,1.24-.34,2.32-1.01,3.24-.67.92-1.6,1.57-2.78,1.96v.06c1.48.17,2.66.73,3.54,1.68.89.94,1.33,2.16,1.33,3.67,0,1.87-.67,3.39-2.02,4.55s-3.04,1.74-5.09,1.74h-6.39Zm2.57-19.58v7.07h2.63c1.41,0,2.51-.34,3.31-1.01.8-.68,1.21-1.64,1.21-2.87,0-2.13-1.4-3.19-4.2-3.19h-2.95Zm0,9.38v7.88h3.48c1.51,0,2.67-.36,3.5-1.07.84-.71,1.25-1.69,1.25-2.93,0-2.59-1.76-3.88-5.29-3.88h-2.95Zm27.57,3.01h-11.04c.04,1.74.51,3.09,1.41,4.03.9.95,2.13,1.42,3.7,1.42,1.76,0,3.38-.58,4.86-1.74v2.35c-1.37,1-3.19,1.5-5.45,1.5s-3.95-.71-5.21-2.12c-1.26-1.43-1.89-3.43-1.89-6,0-2.43.69-4.41,2.06-5.94,1.39-1.54,3.1-2.31,5.15-2.31s3.63.66,4.75,1.99c1.12,1.32,1.68,3.16,1.68,5.51v1.31Zm-2.57-2.12c-.01-1.45-.36-2.57-1.05-3.38-.68-.8-1.63-1.21-2.86-1.21s-2.18.42-3.01,1.27c-.82.85-1.33,1.95-1.53,3.31h8.45Zm19.68,9.32h-2.51v-2.66h-.06c-1.16,2.02-2.95,3.02-5.38,3.02-1.97,0-3.54-.7-4.72-2.09-1.17-1.41-1.76-3.31-1.76-5.73,0-2.59.65-4.66,1.96-6.22,1.3-1.56,3.04-2.34,5.21-2.34s3.71.85,4.69,2.54h.06v-9.69h2.51v23.16Zm-2.51-7.07v-2.31c0-1.26-.42-2.33-1.25-3.21-.84-.88-1.89-1.31-3.18-1.31-1.53,0-2.73.56-3.61,1.68-.88,1.12-1.31,2.67-1.31,4.64,0,1.8.42,3.23,1.25,4.28.85,1.04,1.98,1.56,3.39,1.56s2.53-.5,3.39-1.51c.88-1.01,1.31-2.28,1.31-3.82Zm15.71-6.03c-.44-.34-1.07-.5-1.89-.5-1.07,0-1.97.5-2.69,1.51-.71,1.01-1.07,2.38-1.07,4.12v7.97h-2.51v-15.64h2.51v3.22h.06c.36-1.1.9-1.96,1.63-2.57.73-.62,1.55-.93,2.46-.93.65,0,1.15.07,1.5.21v2.6Zm9.24,13.47c-2.31,0-4.16-.73-5.55-2.18-1.37-1.47-2.06-3.41-2.06-5.82,0-2.63.72-4.68,2.15-6.16,1.44-1.48,3.38-2.21,5.82-2.21s4.15.72,5.45,2.15c1.31,1.44,1.97,3.43,1.97,5.97s-.71,4.5-2.12,6c-1.41,1.5-3.29,2.25-5.67,2.25Zm.18-14.27c-1.61,0-2.88.55-3.82,1.65-.94,1.09-1.41,2.6-1.41,4.52s.47,3.31,1.42,4.38c.95,1.07,2.22,1.6,3.8,1.6s2.86-.52,3.73-1.57c.88-1.05,1.31-2.54,1.31-4.48s-.44-3.46-1.31-4.52c-.87-1.06-2.11-1.59-3.73-1.59Zm18.12,14.27c-2.31,0-4.16-.73-5.55-2.18-1.37-1.47-2.06-3.41-2.06-5.82,0-2.63.72-4.68,2.15-6.16,1.44-1.48,3.38-2.21,5.82-2.21s4.15.72,5.45,2.15c1.31,1.44,1.97,3.43,1.97,5.97s-.71,4.5-2.12,6c-1.41,1.5-3.29,2.25-5.67,2.25Zm.18-14.27c-1.61,0-2.88.55-3.82,1.65-.94,1.09-1.41,2.6-1.41,4.52s.47,3.31,1.42,4.38c.95,1.07,2.22,1.6,3.8,1.6s2.86-.52,3.73-1.57c.88-1.05,1.31-2.54,1.31-4.48s-.44-3.46-1.31-4.52c-.87-1.06-2.11-1.59-3.73-1.59Zm33.79,13.9h-2.51v-8.98c0-1.73-.27-2.98-.81-3.76-.53-.77-1.43-1.16-2.69-1.16-1.07,0-1.98.49-2.73,1.47-.74.98-1.12,2.15-1.12,3.51v8.92h-2.51v-9.29c0-3.08-1.19-4.61-3.56-4.61-1.1,0-2.01.46-2.72,1.39-.71.92-1.07,2.11-1.07,3.59v8.92h-2.51v-15.64h2.51v2.47h.06c1.11-1.89,2.73-2.84,4.86-2.84,1.07,0,2,.3,2.8.9.79.59,1.34,1.37,1.63,2.34,1.16-2.16,2.89-3.24,5.19-3.24,3.44,0,5.16,2.12,5.16,6.37v9.64Z" />
				<path d="m222.74,342.78h-1.82v-13.77c-.14.14-.35.3-.62.49-.27.18-.57.36-.91.53-.33.18-.69.34-1.07.5-.37.16-.73.28-1.09.37v-1.84c.4-.11.82-.26,1.27-.44.45-.19.89-.4,1.32-.63.44-.24.85-.48,1.23-.73.39-.26.72-.51,1-.76h.69v16.29Zm12.28,0h-1.82v-13.77c-.14.14-.35.3-.62.49-.27.18-.57.36-.91.53-.33.18-.69.34-1.07.5-.37.16-.73.28-1.09.37v-1.84c.4-.11.82-.26,1.27-.44.45-.19.89-.4,1.32-.63.44-.24.85-.48,1.23-.73.39-.26.72-.51,1-.76h.69v16.29Z" />
				<rect x="241.07" y="326.85" width="1.61" height="4.97" />
				<path d="m253.86,326.85v10.52h2.04v1.67h-2.04v3.74h-1.8v-3.74h-7.49v-1.58c.7-.79,1.4-1.62,2.11-2.51.71-.9,1.39-1.8,2.03-2.72.65-.92,1.25-1.83,1.8-2.74.56-.92,1.02-1.8,1.4-2.63h1.94Zm-7.23,10.52h5.43v-7.8c-.56.97-1.08,1.84-1.58,2.6-.5.76-.97,1.46-1.42,2.08-.44.62-.87,1.19-1.28,1.69-.41.5-.79.98-1.16,1.43Z" />
				<path d="m260.12,326.85v4.97h-1.61v-4.97h1.61Zm3.69,0v4.97h-1.61v-4.97h1.61Z" />
				<path d="m282.02,331.41l-3.82,5.76,3.76,5.62h-2.12l-2.23-3.69c-.14-.23-.31-.52-.5-.87h-.04c-.04.07-.21.36-.52.87l-2.28,3.69h-2.1l3.88-5.58-3.71-5.8h2.12l2.2,3.89c.16.29.32.59.48.89h.04l2.84-4.78h2.01Z" />
				<path d="m296.59,342.78h-1.82v-13.77c-.14.14-.35.3-.62.49-.27.18-.57.36-.91.53-.33.18-.69.34-1.07.5-.37.16-.73.28-1.09.37v-1.84c.4-.11.82-.26,1.27-.44.45-.19.89-.4,1.32-.63.44-.24.85-.48,1.23-.73.39-.26.72-.51,1-.76h.69v16.29Zm12.82-11.76c0-.49-.08-.91-.23-1.28-.15-.36-.36-.66-.62-.9-.26-.24-.57-.43-.92-.54-.36-.12-.74-.18-1.16-.18-.36,0-.7.05-1.04.14-.34.1-.67.23-1,.4-.32.17-.63.37-.93.61-.3.24-.57.5-.83.79v-1.96c.51-.5,1.08-.87,1.71-1.13.64-.27,1.41-.4,2.32-.4.65,0,1.26.1,1.81.29.56.19,1.04.46,1.44.82.41.36.73.81.96,1.34.24.53.36,1.14.36,1.83,0,.63-.07,1.2-.22,1.71-.14.51-.36.99-.66,1.44-.29.45-.66.89-1.1,1.3s-.97.84-1.57,1.27c-.75.53-1.37.99-1.86,1.37-.48.38-.87.73-1.16,1.07-.28.33-.48.66-.6.99-.11.33-.17.7-.17,1.13h7.93v1.63h-9.83v-.79c0-.68.07-1.28.22-1.8.15-.52.39-1.01.73-1.48s.79-.93,1.33-1.4c.56-.47,1.23-.99,2.03-1.58.58-.41,1.06-.81,1.44-1.19.39-.38.71-.76.94-1.13s.4-.76.5-1.14c.1-.39.16-.81.16-1.24Z" />
				<rect x="314.93" y="326.85" width="1.61" height="4.97" />
				<path d="m326.32,342.78h-1.82v-13.77c-.14.14-.35.3-.62.49-.27.18-.57.36-.91.53-.33.18-.69.34-1.07.5-.37.16-.73.28-1.09.37v-1.84c.4-.11.82-.26,1.27-.44.45-.19.89-.4,1.32-.63.44-.24.85-.48,1.23-.73.39-.26.72-.51,1-.76h.69v16.29Z" />
				<path d="m333.98,326.85v4.97h-1.61v-4.97h1.61Zm3.69,0v4.97h-1.61v-4.97h1.61Z" />
				<path d="m678.07,718.63h-3.57l-8.46-10.02c-.32-.38-.51-.63-.58-.76h-.06v10.78h-2.57v-21.91h2.57v10.3h.06c.14-.22.34-.47.58-.75l8.19-9.55h3.19l-9.39,10.51,10.05,11.4Zm3.82-19.61c-.45,0-.83-.15-1.15-.46-.32-.31-.47-.69-.47-1.16s.16-.86.47-1.16c.32-.32.7-.47,1.15-.47s.85.16,1.16.47c.33.31.49.69.49,1.16s-.16.83-.49,1.15c-.32.32-.7.47-1.16.47Zm1.22,19.61h-2.51v-15.64h2.51v15.64Zm12.3-.15c-.59.33-1.37.49-2.34.49-2.74,0-4.11-1.53-4.11-4.58v-9.26h-2.69v-2.14h2.69v-3.82l2.51-.81v4.63h3.94v2.14h-3.94v8.81c0,1.05.18,1.8.53,2.25s.95.67,1.77.67c.63,0,1.18-.17,1.63-.52v2.14Zm13.99-.57c-1.2.72-2.63,1.08-4.28,1.08-2.23,0-4.03-.72-5.41-2.17-1.36-1.46-2.05-3.34-2.05-5.65,0-2.58.74-4.64,2.22-6.2,1.48-1.57,3.45-2.35,5.91-2.35,1.37,0,2.59.25,3.64.76v2.57c-1.16-.81-2.4-1.22-3.73-1.22-1.6,0-2.91.58-3.94,1.73-1.02,1.14-1.53,2.64-1.53,4.51s.48,3.28,1.44,4.34c.97,1.06,2.26,1.59,3.88,1.59,1.36,0,2.65-.45,3.85-1.36v2.38Zm16.75.72h-2.51v-9.01c0-3.26-1.21-4.89-3.64-4.89-1.22,0-2.25.47-3.09,1.42-.84.94-1.25,2.14-1.25,3.62v8.86h-2.51v-23.16h2.51v10.11h.06c1.2-1.98,2.91-2.96,5.13-2.96,3.52,0,5.29,2.12,5.29,6.37v9.64Zm17.27-7.2h-11.04c.04,1.74.51,3.09,1.41,4.03.9.95,2.13,1.42,3.7,1.42,1.76,0,3.38-.58,4.86-1.74v2.35c-1.37,1-3.19,1.5-5.45,1.5s-3.95-.71-5.21-2.12c-1.26-1.43-1.89-3.43-1.89-6,0-2.43.69-4.41,2.06-5.94,1.39-1.54,3.1-2.31,5.15-2.31s3.63.66,4.75,1.99c1.12,1.32,1.68,3.16,1.68,5.51v1.31Zm-2.57-2.12c-.01-1.45-.36-2.57-1.05-3.38-.68-.8-1.63-1.21-2.86-1.21s-2.18.42-3.01,1.27c-.82.85-1.33,1.95-1.53,3.31h8.45Zm19.32,9.32h-2.51v-8.92c0-3.32-1.21-4.98-3.64-4.98-1.25,0-2.29.47-3.12,1.42-.81.94-1.22,2.12-1.22,3.56v8.92h-2.51v-15.64h2.51v2.6h.06c1.18-1.98,2.89-2.96,5.13-2.96,1.71,0,3.02.56,3.93,1.67.91,1.1,1.36,2.69,1.36,4.78v9.56Z" />
				<path d="m422.01,823.29h-11.61v-21.91h11.12v2.32h-8.55v7.29h7.91v2.31h-7.91v7.67h9.04v2.32Zm16.89,0h-2.51v-8.92c0-3.32-1.21-4.98-3.64-4.98-1.25,0-2.29.47-3.12,1.42-.81.94-1.22,2.12-1.22,3.56v8.92h-2.51v-15.64h2.51v2.6h.06c1.18-1.98,2.89-2.96,5.13-2.96,1.71,0,3.02.56,3.93,1.67.91,1.1,1.36,2.69,1.36,4.78v9.56Zm12-.15c-.59.33-1.37.49-2.34.49-2.74,0-4.11-1.53-4.11-4.58v-9.26h-2.69v-2.14h2.69v-3.82l2.51-.81v4.63h3.94v2.14h-3.94v8.81c0,1.05.18,1.8.53,2.25.36.45.95.67,1.77.67.63,0,1.18-.17,1.63-.52v2.14Zm11.53-12.95c-.44-.34-1.07-.5-1.89-.5-1.07,0-1.97.5-2.69,1.51-.71,1.01-1.07,2.38-1.07,4.12v7.97h-2.51v-15.64h2.51v3.22h.06c.36-1.1.9-1.96,1.63-2.57.73-.62,1.55-.93,2.46-.93.65,0,1.15.07,1.5.21v2.6Zm15.2-2.54l-7.2,18.15c-1.28,3.24-3.09,4.86-5.41,4.86-.65,0-1.2-.07-1.63-.2v-2.25c.54.18,1.03.27,1.48.27,1.26,0,2.21-.75,2.84-2.26l1.25-2.96-6.11-15.61h2.78l4.23,12.04c.05.15.16.55.32,1.19h.09c.05-.24.15-.63.31-1.16l4.45-12.07h2.6Z" />
				<path d="m190.42,794.23v-21.91h6.23c1.89,0,3.4.46,4.51,1.39,1.11.93,1.67,2.13,1.67,3.62,0,1.24-.34,2.32-1.01,3.24-.67.92-1.6,1.57-2.78,1.96v.06c1.48.17,2.66.73,3.54,1.68.89.94,1.33,2.16,1.33,3.67,0,1.87-.67,3.39-2.02,4.55-1.34,1.16-3.04,1.74-5.09,1.74h-6.39Zm2.57-19.58v7.07h2.63c1.41,0,2.51-.34,3.31-1.01.8-.68,1.21-1.64,1.21-2.87,0-2.13-1.4-3.19-4.2-3.19h-2.95Zm0,9.38v7.88h3.48c1.51,0,2.67-.36,3.5-1.07.84-.71,1.25-1.69,1.25-2.93,0-2.59-1.76-3.88-5.29-3.88h-2.95Zm26.22,10.2h-2.51v-2.44h-.06c-1.09,1.87-2.69,2.81-4.81,2.81-1.56,0-2.78-.41-3.67-1.24-.88-.83-1.31-1.92-1.31-3.28,0-2.92,1.72-4.62,5.16-5.1l4.69-.66c0-2.66-1.07-3.99-3.22-3.99-1.88,0-3.58.64-5.1,1.92v-2.57c1.54-.98,3.31-1.47,5.32-1.47,3.68,0,5.51,1.95,5.51,5.84v10.17Zm-2.51-7.91l-3.77.52c-1.16.16-2.04.45-2.63.87-.59.41-.89,1.14-.89,2.18,0,.76.27,1.39.81,1.88.55.48,1.28.72,2.18.72,1.24,0,2.27-.43,3.07-1.3.81-.88,1.22-1.98,1.22-3.31v-1.56Zm14.48,7.76c-.59.33-1.37.49-2.34.49-2.74,0-4.11-1.53-4.11-4.58v-9.26h-2.69v-2.14h2.69v-3.82l2.51-.81v4.63h3.94v2.14h-3.94v8.81c0,1.05.18,1.8.53,2.25.36.45.95.67,1.77.67.63,0,1.18-.17,1.63-.52v2.14Zm16.33.15h-2.51v-9.01c0-3.26-1.21-4.89-3.64-4.89-1.22,0-2.25.47-3.09,1.42-.84.94-1.25,2.14-1.25,3.62v8.86h-2.51v-23.16h2.51v10.11h.06c1.2-1.98,2.91-2.96,5.13-2.96,3.52,0,5.29,2.12,5.29,6.37v9.64Z" />
				<path d="m428.62,534.33l-3.93,13.93h-1.91l-2.87-10.18c-.12-.43-.2-.91-.22-1.42h-.04c-.04.48-.12.95-.25,1.4l-2.89,10.2h-1.89l-4.08-13.93h1.8l2.96,10.69c.12.45.2.91.23,1.4h.05c.03-.34.13-.81.3-1.4l3.08-10.69h1.56l2.95,10.76c.1.37.18.8.23,1.3h.04c.03-.34.11-.78.26-1.34l2.85-10.73h1.77Z" />
				<polygon points="436.76 534.33 430.07 550.58 428.59 550.58 435.25 534.33 436.76 534.33" />
				<path d="m438.38,548.26v-13.93h3.85c4.91,0,7.36,2.26,7.36,6.79,0,2.15-.68,3.88-2.05,5.19-1.36,1.3-3.18,1.95-5.47,1.95h-3.69Zm1.63-12.46v10.98h2.08c1.83,0,3.25-.49,4.27-1.47s1.53-2.36,1.53-4.16c0-3.57-1.9-5.35-5.69-5.35h-2.18Z" />
			</g>
		</g>
	)
}

export default PlanN
